const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    let allSettled2 = function(promises) {
      return Promise.all(
        promises.map(
          (p) => Promise.resolve(p).then(
            (value) => ({ status: "fulfilled", value }),
            (reason) => ({ status: "rejected", reason })
          )
        )
      );
    };
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = (cspNonceMeta == null ? void 0 : cspNonceMeta.nonce) || (cspNonceMeta == null ? void 0 : cspNonceMeta.getAttribute("nonce"));
    promise = allSettled2(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
        }
        link.crossOrigin = "";
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  function handlePreloadError(err) {
    const e = new Event("vite:preloadError", {
      cancelable: true
    });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
const __variableDynamicImportRuntimeHelper = (glob, path, segs) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(
      reject.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
function productRenderRoot(html, root) {
  const blockId = root.dataset.productBlockId;
  if (!blockId) return html;
  return Array.from(html.querySelectorAll("[data-product-block-id]")).find((element) => element.dataset.productBlockId === blockId) ?? null;
}
function productRenderUrl(root) {
  var _a;
  const sourceUrl = new URL(root.dataset.productRenderUrl || window.location.href, window.location.origin);
  if (root.dataset.productBlockId && root.dataset.productUrl) {
    let productPath = new URL(root.dataset.productUrl, sourceUrl.origin).pathname;
    const localePrefix = ((_a = sourceUrl.pathname.match(/^(.*?)\/(?:pages|products)\//)) == null ? void 0 : _a[1]) ?? "";
    if (localePrefix && productPath.startsWith("/products/")) {
      productPath = localePrefix + productPath;
    }
    sourceUrl.pathname = productPath;
  }
  return sourceUrl;
}
const products = {
  /**
   * Initializes variant selection
   * - If enableDefaultVariant is true, sets the current variant
   * - If false, checks for variant parameter in URL
   * - Also attaches form handlers
   * @returns {void}
   */
  initProduct() {
    var _a;
    try {
      this.purchaseOffersPending = !this.purchaseOfferState && Array.from(
        ((_a = this.$root) == null ? void 0 : _a.querySelectorAll("[data-purchase-offers]")) ?? []
      ).some(
        (selector) => selector.closest("[data-product-handle], .product-card") === this.$root
      );
      this.refreshQuickFlags();
      this.attachForm();
      if (this.isProductCard !== true) {
        this.addProductToRecentView(this.handle);
      }
      if (this.enableDefaultVariant) {
        if (this.variantId) {
          this.handleProductFormChange(this.variantId);
        }
      } else {
        this.checkUrlForVariant();
      }
    } catch (error2) {
      console.error("products: Error in initProduct:", error2);
    }
  },
  /**
   * Attaches Alpine.js submit handlers to all product forms inside the component root
   * @returns {void}
   */
  attachForm() {
    try {
      const rootEl = this.$root;
      if (!rootEl) return;
      const productForms = Array.from(
        rootEl.querySelectorAll("[data-product-form]")
      );
      if (!productForms.length) {
        return;
      }
      let submitHandler = "loading = true; submitProductForm($event.target, true); setTimeout(function(){ loading = false}, 500);";
      if (this.isQuickEdit) {
        this.quantity = Alpine.store("cart").editQuantity;
        submitHandler = 'loading = true; editCartItem($event.target); closeOverlay("theme__quickedit"); setTimeout(function(){ loading = false}, 500);';
      } else if (this.isQuickBuy) {
        submitHandler = 'loading = true; submitProductForm($event.target, true); closeOverlay("theme__quickbuy"); setTimeout(function(){ loading = false}, 500);';
      }
      for (const productForm of productForms) {
        productForm.setAttribute("x-on:submit.prevent", submitHandler);
      }
    } catch (error2) {
      console.error("products: Error in attachForm:", error2);
    }
  },
  /**
   * Checks for variant parameter in URL and sets the variant if found
   * - Only runs when enableDefaultVariant is false
   * @returns {void}
   */
  checkUrlForVariant() {
    try {
      const root = this.$root;
      if ((root == null ? void 0 : root.dataset.productBlockId) && !root.dataset.productRenderUrl) return;
      const urlParams = new URLSearchParams((root == null ? void 0 : root.dataset.productRenderUrl) ? productRenderUrl(root).search : window.location.search);
      const variantId = urlParams.get("variant");
      if (!variantId) return;
      const parsedVariantId = parseInt(variantId, 10);
      if (isNaN(parsedVariantId)) {
        console.warn("products: Invalid variant ID in URL:", variantId);
        return;
      }
      this.handleProductFormChange(parsedVariantId);
    } catch (error2) {
      console.error("products: Error in checkUrlForVariant:", error2);
    }
  },
  /**
   * Checks parent containers for quick buy/edit flags and updates product object
   * - Looks for [data-quick-buy] or [data-quick-edit] parent containers
   * - Reads isQuickEdit and isQuickBuy values from parent Alpine.js data
   * @returns {void}
   */
  refreshQuickFlags() {
    var _a, _b, _c, _d;
    try {
      const rootEl = this.$root;
      if (!rootEl) return;
      const quickBuyContainer = rootEl.closest("[data-quick-buy]");
      const quickEditContainer = rootEl.closest("[data-quick-edit]");
      if (quickBuyContainer) {
        const parentData = ((_a = quickBuyContainer.__x) == null ? void 0 : _a.$data) || ((_b = Alpine.$data) == null ? void 0 : _b.call(Alpine, quickBuyContainer));
        if (parentData) {
          this.isQuickBuy = parentData.isQuickBuy ?? this.isQuickBuy;
          this.isQuickEdit = parentData.isQuickEdit ?? this.isQuickEdit;
        }
      }
      if (quickEditContainer) {
        const parentData = ((_c = quickEditContainer.__x) == null ? void 0 : _c.$data) || ((_d = Alpine.$data) == null ? void 0 : _d.call(Alpine, quickEditContainer));
        if (parentData) {
          this.isQuickEdit = parentData.isQuickEdit ?? this.isQuickEdit;
          this.isQuickBuy = parentData.isQuickBuy ?? this.isQuickBuy;
        }
      }
    } catch (error2) {
      console.error("products: Error in refreshQuickFlags:", error2);
    }
  },
  /**
   * Updates the product page when variant selection changes.
   * Supports high-variant products (250+) by using the Section Rendering API
   * to refresh option availability when called from an option button click.
   * @param {number} [preselectedVariantId] - The ID of the variant to select (used during init/URL load)
   * @param {string} [productUrl] - Product URL from the clicked option value (used for combined listings)
   * @returns {void}
   */
  handleProductFormChange(preselectedVariantId, productUrl) {
    try {
      this.productLoading = true;
      if (this.isVariantCard && this.cardVariantId) {
        preselectedVariantId = this.cardVariantId;
        productUrl = void 0;
      }
      this.setOptionsFromPreselectedVariantId(preselectedVariantId);
      this.setSelectedVariant();
      this.validateSellingPlanForSelectedVariant();
      this.setUnavailableOptions();
      this.setNeverAvailableOptions();
      this.setAllOptionsSelected();
      this.updateUrlParameters();
      this.updateSellingPlanSavings();
      this.updateCalculatedPrice();
      if (this.selectedVariant && this.selectedVariant.id) {
        this.fetchAndRefreshPickup(this.selectedVariant.id);
      }
      if (!preselectedVariantId) {
        this.refreshOptionAvailability(productUrl);
      }
      setTimeout(() => {
        this.productLoading = false;
      }, 300);
    } catch (error2) {
      console.error("products: Error in handleProductFormChange:", error2);
      this.productLoading = false;
    }
  },
  /**
   * Sets product options based on a preselected variant ID
   * @param {number} preselectedVariantId - The ID of the variant to match options against
   * @returns {void}
   */
  setOptionsFromPreselectedVariantId(preselectedVariantId) {
    try {
      if (!preselectedVariantId) return;
      this.variantId = preselectedVariantId;
      const selectedVariant = this.product.variants.find(
        (variant) => variant.id === preselectedVariantId
      );
      if (!selectedVariant) return;
      ["option1", "option2", "option3"].forEach((optionKey, index) => {
        if (index < this.product.options.length && selectedVariant[optionKey]) {
          this[optionKey] = this.encodeToBase64(selectedVariant[optionKey]);
        }
      });
    } catch (error2) {
      console.error("products: Error in setOptionsFromPreselectedVariantId:", error2);
    }
  },
  /**
   * Finds the variant that matches the currently selected options and sets this.selectedVariant
   * @returns {void}
   */
  setSelectedVariant() {
    var _a, _b, _c;
    try {
      if (!((_b = (_a = this.product) == null ? void 0 : _a.variants) == null ? void 0 : _b.length)) {
        this.selectedVariant = null;
        return;
      }
      const selectedOptions = [this.option1, this.option2, this.option3].slice(0, this.product.options.length).filter((option) => option !== void 0);
      if (selectedOptions.length !== this.product.options.length) {
        this.selectedVariant = null;
        return;
      }
      this.selectedVariant = this.product.variants.find((variant) => {
        return selectedOptions.every((selectedOption, index) => {
          const variantOption = variant[`option${index + 1}`];
          return this.encodeToBase64(variantOption) === selectedOption;
        });
      }) || null;
      if (this.selectedVariant) {
        this.variantId = this.selectedVariant.id;
        this.variantFeaturedImageId = (_c = this.selectedVariant.featured_image) == null ? void 0 : _c.id;
      }
    } catch (error2) {
      console.error("products: Error in setSelectedVariant:", error2);
    }
  },
  /**
   * Ensures the selected selling plan is available for the current variant.
   * Falls back to the last selected plan, the active group, or one-time purchase.
   * @returns {void}
   */
  validateSellingPlanForSelectedVariant() {
    var _a;
    try {
      if (!this.variantSellingPlanId || this.variantSellingPlanId === 0) {
        return;
      }
      const allocations = ((_a = this.selectedVariant) == null ? void 0 : _a.selling_plan_allocations) ?? [];
      const currentAllocation = allocations.find(
        (allocation) => allocation.selling_plan_id == this.variantSellingPlanId
      );
      if (currentAllocation) {
        if (currentAllocation.selling_plan_group_id != null) {
          this.variantSellingGroupId = currentAllocation.selling_plan_group_id;
        }
        this.lastSelectedSellingPlanId = this.variantSellingPlanId;
        return;
      }
      const lastSelectedAllocation = allocations.find(
        (allocation) => allocation.selling_plan_id == this.lastSelectedSellingPlanId
      );
      if (lastSelectedAllocation) {
        this.variantSellingPlanId = lastSelectedAllocation.selling_plan_id;
        this.variantSellingGroupId = lastSelectedAllocation.selling_plan_group_id ?? this.variantSellingGroupId;
        this.lastSelectedSellingPlanId = lastSelectedAllocation.selling_plan_id;
        return;
      }
      if (this.variantSellingGroupId && this.variantSellingGroupId !== 0) {
        const groupAllocation = allocations.find(
          (allocation) => allocation.selling_plan_group_id == this.variantSellingGroupId
        );
        if (groupAllocation) {
          this.variantSellingPlanId = groupAllocation.selling_plan_id;
          this.variantSellingGroupId = groupAllocation.selling_plan_group_id ?? this.variantSellingGroupId;
          this.lastSelectedSellingPlanId = groupAllocation.selling_plan_id;
          return;
        }
      }
      if (this.variantSellingGroupId !== 0) {
        this.variantSellingPlanId = 0;
        this.variantSellingGroupId = 0;
      }
    } catch (error2) {
      console.error("products: Error in validateSellingPlanForSelectedVariant:", error2);
    }
  },
  /**
   * Sets options that are not available based on selected options
   * @returns {void}
   */
  setUnavailableOptions() {
    var _a, _b, _c, _d;
    try {
      if (!((_b = (_a = this.product) == null ? void 0 : _a.variants) == null ? void 0 : _b.length) || !((_d = (_c = this.product) == null ? void 0 : _c.options) == null ? void 0 : _d.length)) {
        return;
      }
      const allCombinations = this._generateOptionCombinations();
      const nonExistentVariants = this._findNonExistentVariants(allCombinations);
      for (let i = 1; i <= this.product.options.length; i++) {
        this[`unavailableOption${i}`] = this._getUnavailableOptionsForPosition(i, nonExistentVariants);
      }
    } catch (error2) {
      console.error("products: Error in setUnavailableOptions:", error2);
    }
  },
  /**
   * Sets options that are never available regardless of selection context.
   * An option value is added when no available variant exists containing that value,
   * regardless of what other options are selected. Used by the 'empty' unavailable_indication mode.
   * @returns {void}
   */
  setNeverAvailableOptions() {
    var _a, _b, _c, _d;
    try {
      if (!((_b = (_a = this.product) == null ? void 0 : _a.variants) == null ? void 0 : _b.length) || !((_d = (_c = this.product) == null ? void 0 : _c.options) == null ? void 0 : _d.length)) return;
      if (this.product.variants.length >= 250) {
        for (let i = 1; i <= this.product.options.length; i++) {
          this[`neverAvailableOption${i}`] = [];
        }
        return;
      }
      for (let i = 1; i <= this.product.options.length; i++) {
        const optionKey = `option${i}`;
        const allValues = [...new Set(
          this.product.variants.map((v) => v[optionKey])
        )];
        const neverAvailable = [];
        for (const value of allValues) {
          const hasAvailableVariant = this.product.variants.some(
            (v) => v[optionKey] === value && v.available
          );
          if (!hasAvailableVariant) {
            neverAvailable.push(this.encodeToBase64(value));
          }
        }
        this[`neverAvailableOption${i}`] = neverAvailable;
      }
    } catch (error2) {
      console.error("products: Error in setNeverAvailableOptions:", error2);
    }
  },
  /**
   * Updates allOptionsSelected based on whether all product options are selected
   * - Checks if the number of selected options matches the total number of product options
   * @returns {void}
   */
  setAllOptionsSelected() {
    try {
      const optionsSize = this.product.options.length;
      this.allOptionsSelected = optionsSize === 1 && this.option1 || optionsSize === 2 && this.option1 && this.option2 || optionsSize === 3 && this.option1 && this.option2 && this.option3;
    } catch (error2) {
      console.error("products: Error in setAllOptionsSelected:", error2);
    }
  },
  /**
   * Updates URL parameters to include the selected variant ID
   * - Only updates the URL if on a product page and all options are selected
   * - Uses history.replaceState to avoid adding entries to browser history
   * @returns {void}
   */
  updateUrlParameters() {
    try {
      if (this.enableUrlUpdate === false) {
        return;
      }
      if (window.location.pathname.includes("/products/") && this.allOptionsSelected) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("variant", this.variantId);
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.replaceState(null, "", newRelativePathQuery);
      }
    } catch (error2) {
      console.error("products: Error in updateUrlParameters:", error2);
    }
  },
  /**
   * Calculates and updates selling plan savings text
   * - Updates variantSellingPlanSavingsText
   * @returns {void}
   */
  updateSellingPlanSavings() {
    var _a, _b;
    try {
      this.variantSellingPlanSavingsText = null;
      if (!this.variantSellingPlanId || this.variantSellingPlanId === 0) {
        return;
      }
      const sellingPlan = this.sellingPlans[this.variantSellingPlanId];
      if (!sellingPlan || !sellingPlan.price_adjustments || sellingPlan.price_adjustments.length === 0) {
        return;
      }
      const priceAdjustment = sellingPlan.price_adjustments[0];
      if (!priceAdjustment || priceAdjustment.value <= 0) {
        return;
      }
      let savingsText = "";
      switch (priceAdjustment.value_type) {
        case "percentage":
          savingsText = `Save ${priceAdjustment.value}%`;
          break;
        case "fixed_amount":
        case "price":
          const formattedAmount = ((_b = (_a = window.Shopify) == null ? void 0 : _a.formatMoney) == null ? void 0 : _b.call(_a, priceAdjustment.value)) || priceAdjustment.value;
          savingsText = `Save ${formattedAmount}`;
          break;
        default:
          return;
      }
      this.variantSellingPlanSavingsText = savingsText;
    } catch (error2) {
      console.error("products: Error in updateSellingPlanSavings:", error2);
    }
  },
  /**
   * Updates the calculated price based on the selected variant and selling plan
   * @returns {void}
   */
  updateCalculatedPrice() {
    var _a;
    try {
      if (this.purchaseOfferState) {
        const selection = this.purchaseOfferState.getSelection(this.product, this.selectedVariant);
        this.calculatedPrice = ((selection == null ? void 0 : selection.price) ?? 0) * this.quantity;
        return;
      }
      if (!this.selectedVariant) {
        this.calculatedPrice = 0;
        return;
      }
      let basePrice = this.selectedVariant.price;
      if (this.variantSellingPlanId) {
        const sellingPlanAllocation = (_a = this.selectedVariant.selling_plan_allocations) == null ? void 0 : _a.find(
          (allocation) => allocation.selling_plan_id == this.variantSellingPlanId
        );
        if (sellingPlanAllocation) {
          basePrice = sellingPlanAllocation.price;
        }
      }
      this.calculatedPrice = basePrice * this.quantity;
    } catch (error2) {
      console.error("products: Error in updateCalculatedPrice:", error2);
    }
  },
  /**
   * Add a product to the recent view
   * @param {string} productHandle - The handle of the product to add
   * @returns {void}
   */
  async addProductToRecentView(productHandle) {
    const fetchProduct = async (handle) => {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error("Failed to fetch product");
      return response.json();
    };
    try {
      const recentlyViewedProducts = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
      if (!recentlyViewedProducts.find((prod) => prod.handle === productHandle)) {
        const newProduct = await fetchProduct(productHandle);
        if (recentlyViewedProducts.length === 12) {
          recentlyViewedProducts.pop();
        }
        const newProducts = [newProduct, ...recentlyViewedProducts];
        localStorage.setItem("recentlyViewedProducts", JSON.stringify(newProducts));
      }
    } catch (error2) {
      console.error("products: Error in addProductToRecentView:", error2);
    }
  },
  /**
   * Fetches the quick buy block and injects it into the page
   * @param {string} productHandle - The handle of the product to fetch the quick buy block for
   * @param {number} variantId - The ID of the variant to edit
   * @param {string} template - The template name to render
   * @param {string} injectSelector - The selector to inject the template into
   * @param {Function} onStart - Optional callback to invoke before fetching
   * @param {Function} onComplete - Optional callback to invoke after successful injection
   * @param {Function} onError - Optional callback to invoke on error
   * @returns {Promise<void>}
   */
  async fetchAndRenderProductTemplate(productHandle, variantId, template, injectSelector, onStart, onComplete, onError) {
    try {
      if (onStart && typeof onStart === "function") {
        onStart();
      }
      const fetchUrl = `/products/${productHandle}?variant=${variantId}&view=${template}`;
      const templateResponse = await fetch(fetchUrl);
      const templateData = await templateResponse.text();
      if (!templateResponse.ok) {
        throw new Error(`HTTP ${templateResponse.status}: ${templateResponse.statusText}`);
      }
      if (!templateData) {
        console.warn("products: No templateData received from fetch");
        if (onError && typeof onError === "function") {
          onError();
        }
        return;
      }
      const tempElementTemplate = document.createElement("div");
      tempElementTemplate.innerHTML = templateData;
      const productSection = tempElementTemplate.querySelector(`[data-product-handle="${productHandle}"]`);
      if (!productSection) {
        console.warn(`products: No section found with data-product-handle="${productHandle}"`);
        if (onError && typeof onError === "function") {
          onError();
        }
        return;
      }
      const sectionId = productSection.getAttribute("data-product-section-id");
      if (!sectionId) {
        console.warn(`products: No data-product-section-id found on section with data-product-handle="${productHandle}"`);
        if (onError && typeof onError === "function") {
          onError();
        }
        return;
      }
      const sectionFetchUrl = `/products/${productHandle}?section_id=${sectionId}&variant=${variantId}&view=${template}`;
      const sectionResponse = await fetch(sectionFetchUrl);
      const sectionData = await sectionResponse.text();
      if (!sectionResponse.ok) {
        if (onError && typeof onError === "function") {
          onError();
        }
        throw new Error(`HTTP ${sectionResponse.status}: ${sectionResponse.statusText}`);
      }
      const tempElementSection = document.createElement("div");
      tempElementSection.innerHTML = sectionData;
      const injectBlock = document.querySelector(injectSelector);
      if (injectBlock) {
        injectBlock.innerHTML = tempElementSection.innerHTML;
        this.loadImages();
        if (onComplete && typeof onComplete === "function") {
          onComplete();
        }
      }
    } catch (error2) {
      console.error("products: Error in fetchAndRenderProductTemplate:", error2);
      if (onError && typeof onError === "function") {
        onError();
      }
    }
  },
  /**
   * Uses the Section Rendering API to refresh option availability and variant data
   * for products with more than 250 variants, where the client-side calculations
   * based on product.variants (capped at 250) may be inaccurate.
   *
   * When called, it:
   * 1. Collects selected option value IDs from data-option-value-id attributes on buttons
   * 2. Fetches the product section with ?option_values=... to get server-computed availability
   * 3. Reads the hidden variant JSON and updates selectedVariant, variantId, price, etc.
   * 4. Reads data-available attributes on buttons to rebuild unavailableOption arrays
   * 5. Handles combined listings by detecting a product URL change
   *
   * @param {string} [productUrl] - Product URL from the clicked option value (for combined listings)
   * @returns {Promise<void>}
   */
  async refreshOptionAvailability(productUrl) {
    var _a, _b;
    try {
      const rootEl = this.$root;
      if (!rootEl) return;
      const sectionId = rootEl.dataset.productSectionId;
      if (!sectionId) return;
      const selectedOptionValueIds = [];
      for (let i = 1; i <= this.product.options.length; i++) {
        const selectedValue = this[`option${i}`];
        if (!selectedValue) continue;
        const btn = rootEl.querySelector(
          `[data-value="${selectedValue}"][data-option-value-id][data-option-position="${i}"]`
        );
        if (btn == null ? void 0 : btn.dataset.optionValueId) {
          selectedOptionValueIds.push(btn.dataset.optionValueId);
        }
      }
      if (selectedOptionValueIds.length === 0) return;
      const currentProductPath = window.location.pathname.split("?")[0];
      const newProductPath = productUrl ? productUrl.split("?")[0] : currentProductPath;
      const isCurrentProduct = rootEl.dataset.productBlockId ? newProductPath.endsWith(`/products/${rootEl.dataset.productHandle}`) : newProductPath === currentProductPath;
      if (productUrl && !isCurrentProduct) {
        if (this.enableUrlUpdate === false) {
          return;
        }
        const params = `option_values=${selectedOptionValueIds.join(",")}`;
        window.location.href = `${newProductPath}?${params}`;
        return;
      }
      const fetchUrl = productRenderUrl(rootEl);
      fetchUrl.searchParams.set("section_id", sectionId);
      fetchUrl.searchParams.set("option_values", selectedOptionValueIds.join(","));
      fetchUrl.searchParams.delete("variant");
      const response = await fetch(fetchUrl.toString());
      if (!response.ok) return;
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const renderedProduct = productRenderRoot(html, rootEl);
      if (!renderedProduct) return;
      const variantDataEl = renderedProduct.querySelector("[data-variant-json]");
      if (variantDataEl == null ? void 0 : variantDataEl.textContent) {
        try {
          const variantData = JSON.parse(variantDataEl.textContent);
          if (variantData && variantData.id) {
            this.selectedVariant = variantData;
            this.variantId = variantData.id;
            this.variantFeaturedImageId = ((_a = variantData.featured_image) == null ? void 0 : _a.id) ?? null;
            this.updateUrlParameters();
            this.updateCalculatedPrice();
            if (variantData.id) {
              this.fetchAndRefreshPickup(variantData.id);
            }
          }
        } catch {
        }
      }
      const allButtons = Array.from(
        renderedProduct.querySelectorAll(`[data-option-value-id]`)
      );
      for (let i = 1; i <= this.product.options.length; i++) {
        const unavailableValues = [];
        for (const btn of allButtons) {
          if (btn.dataset.available === "false" && btn.dataset.value && btn.dataset.optionPosition === String(i)) {
            unavailableValues.push(btn.dataset.value);
          }
        }
        this[`unavailableOption${i}`] = unavailableValues;
      }
      for (let i = 1; i <= this.product.options.length; i++) {
        if (!((_b = this[`neverAvailableOption${i}`]) == null ? void 0 : _b.length)) continue;
        const serverConfirmedAvailable = new Set(
          allButtons.filter((btn) => btn.dataset.optionPosition === String(i) && btn.dataset.available === "true").map((btn) => btn.dataset.value)
        );
        this[`neverAvailableOption${i}`] = this[`neverAvailableOption${i}`].filter(
          (v) => !serverConfirmedAvailable.has(v)
        );
      }
    } catch (error2) {
      console.error("products: Error in refreshOptionAvailability:", error2);
    }
  },
  /**
   * Fetches and refreshes the pickup information for a given product variant.
   * @param {number} variantId - The ID of the product variant to fetch pickup information for.
   * @returns {Promise<void>}
   */
  async fetchAndRefreshPickup(variantId) {
    try {
      const rootEl = this.$root;
      if (!rootEl) return;
      const sectionId = rootEl.getAttribute("data-product-section-id");
      if (!sectionId) return;
      const pickupContainer = rootEl.querySelector("[data-pickup]");
      if (!pickupContainer) return;
      const blockEl = pickupContainer.closest("[id]");
      const blockId = blockEl ? `#${blockEl.id}` : "";
      const url = productRenderUrl(rootEl);
      url.searchParams.set("section_id", sectionId);
      url.searchParams.set("variant", String(variantId));
      url.searchParams.delete("option_values");
      const response = await fetch(url.toString());
      if (!response.ok) {
        console.error("products: Failed to fetch pickup HTML", response.status);
        return;
      }
      const html = document.createElement("div");
      html.innerHTML = await response.text();
      const renderedProduct = productRenderRoot(html, rootEl);
      const fetchedBlock = blockId && renderedProduct ? Array.from(renderedProduct.querySelectorAll("[id]")).find((element) => element.id === blockEl.id) : null;
      const fetchedPickup = fetchedBlock ? fetchedBlock.querySelector("[data-pickup]") : null;
      if (fetchedPickup) {
        pickupContainer.innerHTML = fetchedPickup.innerHTML;
      }
    } catch (error2) {
      console.error("products: Error in fetchAndRefreshPickup:", error2);
    }
  },
  /**
   * Generates all possible combinations of product options
   * @returns {Record<string, string>[]} Array of option combinations
   */
  _generateOptionCombinations() {
    const options = this.product.options.map((option, index) => {
      return [
        ...new Set(
          this.product.variants.map(
            (variant) => this.encodeToBase64(variant[`option${index + 1}`])
          )
        )
      ];
    });
    return options.reduce(
      (acc, option, index) => {
        return acc.flatMap((combination) => {
          return option.map((optionValue) => ({
            ...combination,
            [`option${index + 1}`]: optionValue
          }));
        });
      },
      [{}]
    );
  },
  /**
   * Finds variants that don't exist in the product variants array
   * @param {Record<string, string>[]} allCombinations - All possible option combinations
   * @returns {Record<string, string>[]} Array of non-existent variant combinations
   */
  _findNonExistentVariants(allCombinations) {
    return allCombinations.filter((combination) => {
      return !this.product.variants.some((variant) => {
        return Object.keys(combination).every((optionKey) => {
          return this.encodeToBase64(variant[optionKey]) === combination[optionKey];
        });
      });
    });
  },
  /**
   * Finds variants that match current selections except for specified option position
   * @param {number} excludeOptionIndex - Option position to exclude from matching
   * @returns {ProductVariant[]} Array of unavailable variants
   */
  _findMatchingUnavailableVariants(excludeOptionIndex) {
    return this.product.variants.filter((variant) => {
      if (variant.available) {
        return false;
      }
      if (this.product.options.length === 1) {
        return true;
      }
      for (let i = 1; i <= this.product.options.length; i++) {
        if (i === excludeOptionIndex) continue;
        const optionKey = `option${i}`;
        const currentSelection = this[`option${i}`];
        if (!currentSelection) continue;
        if (this.encodeToBase64(variant[optionKey]) !== currentSelection) {
          return false;
        }
      }
      return true;
    });
  },
  /**
   * Gets unavailable options for a specific option position
   * @param {number} optionPosition - The option position (1, 2, or 3)
   * @param {Record<string, string>[]} nonExistentVariants - Array of non-existent variant combinations
   * @returns {string[]} Array of unavailable option values
   */
  _getUnavailableOptionsForPosition(optionPosition, nonExistentVariants) {
    const matchingVariants = this._findMatchingUnavailableVariants(optionPosition);
    const unavailableOptionsSet = /* @__PURE__ */ new Set();
    for (const variant of matchingVariants) {
      const optionKey = `option${optionPosition}`;
      unavailableOptionsSet.add(this.encodeToBase64(variant[optionKey]));
    }
    for (const variant of nonExistentVariants) {
      const isMatch = Object.keys(variant).every((optionKey) => {
        const optionIndex = parseInt(optionKey.replace("option", ""), 10);
        return optionIndex === optionPosition || variant[optionKey] === this[`option${optionIndex}`];
      });
      if (isMatch) {
        unavailableOptionsSet.add(variant[`option${optionPosition}`]);
      }
    }
    return Array.from(unavailableOptionsSet);
  }
};
function isAutomaticGift(item) {
  var _a;
  return (item == null ? void 0 : item.product_id) != null && String(((_a = item.properties) == null ? void 0 : _a.__automatic_gift) ?? "") === String(item.product_id);
}
const lineTotal = (item) => (
  // Ajax line_price includes cart-level discounts, matching cart.total_price.
  Number(item.line_price ?? item.final_line_price ?? 0)
);
class AutomaticGiftCoordinator {
  constructor() {
    this.groups = /* @__PURE__ */ new Map();
    this.pending = null;
    this.updates = 0;
    this.fingerprint = "";
    this.failedProducts = /* @__PURE__ */ new Set();
    this.failedRemovals = /* @__PURE__ */ new Set();
  }
  register(id, rules) {
    this.groups.set(id, rules);
    this.fingerprint = "";
  }
  unregister(id) {
    this.groups.delete(id);
    this.fingerprint = "";
  }
  async reconcile(data2, client) {
    if (!this.pending && !this.groups.size && !data2.items.some(isAutomaticGift))
      return data2;
    const previous = this.pending;
    const run = async () => {
      if (previous) {
        await previous;
        const refreshed = await client.fetchCart();
        if (!refreshed) return data2;
        data2 = refreshed;
      }
      return this.sync(data2, client);
    };
    const pending = run();
    this.pending = pending;
    try {
      return await pending;
    } finally {
      if (this.pending === pending) this.pending = null;
    }
  }
  async sync(data2, client) {
    const merchandise = data2.items.filter((item) => !isAutomaticGift(item));
    const fingerprint = JSON.stringify([
      merchandise,
      data2.total_price - data2.items.filter(isAutomaticGift).reduce((total, item) => total + lineTotal(item), 0),
      data2.discount_codes,
      [...this.groups]
    ]);
    if (fingerprint !== this.fingerprint) {
      this.failedProducts.clear();
      this.failedRemovals.clear();
      this.fingerprint = fingerprint;
    }
    const attempted = new Set(this.failedProducts);
    while (true) {
      const rules = [...this.groups.values()].flat();
      const gifts = data2.items.filter(isAutomaticGift);
      const purchasedItems = data2.items.filter(
        (item) => !isAutomaticGift(item)
      );
      const spend = Math.max(
        0,
        data2.total_price - gifts.reduce((total, item) => total + lineTotal(item), 0)
      );
      const subscription = purchasedItems.some(
        (item) => Boolean(item.selling_plan_allocation)
      );
      const eligible = /* @__PURE__ */ new Map();
      for (const rule of rules) {
        if (rule.productId <= 0 || rule.variantId <= 0 || eligible.has(rule.productId))
          continue;
        const qualifies = purchasedItems.length > 0 && (rule.condition === "subscription" ? subscription : spend >= Math.max(0, rule.minimumSpend));
        if (qualifies) eligible.set(rule.productId, rule);
      }
      const removals = [];
      const kept = /* @__PURE__ */ new Set();
      for (const item of gifts) {
        const rule = eligible.get(item.product_id);
        if (!rule || item.variant_id !== rule.variantId || item.quantity !== 1 || kept.has(item.product_id)) {
          removals.push(item.key);
        } else {
          kept.add(item.product_id);
        }
      }
      if (removals.length) {
        if (removals.some((key) => this.failedRemovals.has(key))) break;
        const next2 = await client.removeCartItems(removals, {
          updateCart: false
        });
        if (!next2 || JSON.stringify(next2.items) === JSON.stringify(data2.items)) {
          for (const key of removals) this.failedRemovals.add(key);
          break;
        }
        data2 = next2;
        continue;
      }
      const missing = [...eligible.values()].find(
        (rule) => !kept.has(rule.productId) && !attempted.has(rule.productId)
      );
      if (!missing) break;
      attempted.add(missing.productId);
      const next = await client.addCartItem(missing.variantId, 0, 1, false, {
        properties: { __automatic_gift: String(missing.productId) },
        updateCart: false
      });
      if (!next) {
        this.failedProducts.add(missing.productId);
        continue;
      }
      data2 = next;
      if (!data2.items.some(
        (item) => isAutomaticGift(item) && item.product_id === missing.productId
      )) {
        this.failedProducts.add(missing.productId);
      }
    }
    return data2;
  }
}
const coordinators = /* @__PURE__ */ new WeakMap();
function getAutomaticGiftCoordinator(store2) {
  let coordinator = coordinators.get(store2);
  if (!coordinator) {
    coordinator = new AutomaticGiftCoordinator();
    coordinators.set(store2, coordinator);
  }
  return coordinator;
}
function cartGifts() {
  return {
    groupId: Symbol("automatic-gifts"),
    init() {
      const rules = Array.from(
        this.$el.querySelectorAll("[data-cart-gift-rule]")
      ).map(
        (element) => ({
          productId: Number(element.dataset.productId) || 0,
          variantId: Number(element.dataset.variantId) || 0,
          condition: element.dataset.condition === "subscription" ? "subscription" : "minimum_spend",
          minimumSpend: Number(element.dataset.minimumSpend) || 0
        })
      );
      this.registerGiftRules(this.groupId, rules);
    },
    async registerGiftRules(groupId, rules) {
      const store2 = Alpine.store("cart");
      getAutomaticGiftCoordinator(store2).register(groupId, rules);
      if (store2.hydrated && !store2.loading) await this.updateCart(false);
    },
    async unregisterGiftRules(groupId) {
      const store2 = Alpine.store("cart");
      getAutomaticGiftCoordinator(store2).unregister(groupId);
      if (store2.hydrated && !store2.loading) await this.updateCart(false);
    },
    destroy() {
      this.unregisterGiftRules(this.groupId);
    }
  };
}
const cartGifts$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cartGifts,
  getAutomaticGiftCoordinator,
  isAutomaticGift
}, Symbol.toStringTag, { value: "Module" }));
const cartUpsellProductRequests = /* @__PURE__ */ new Map();
const isCartUpsellEligible = (item, product, upsellType) => {
  var _a;
  if (!item || !Array.isArray(product == null ? void 0 : product.variants)) return false;
  const currentVariantId = Number(item.variant_id);
  const currentVariant = product.variants.find(
    (variant) => Number(variant.id) === currentVariantId
  );
  if (upsellType === "subscription") {
    if (item.selling_plan_allocation) return false;
    return Boolean((_a = currentVariant == null ? void 0 : currentVariant.selling_plan_allocations) == null ? void 0 : _a.length);
  }
  if (upsellType !== "variant") return false;
  const currentPrice = Number(
    (currentVariant == null ? void 0 : currentVariant.price) ?? item.original_price ?? item.price
  );
  if (!Number.isFinite(currentPrice)) return false;
  return product.variants.some((variant) => {
    const variantPrice = Number(variant.price);
    return variant.available === true && Number(variant.id) !== currentVariantId && Number.isFinite(variantPrice) && variantPrice > currentPrice;
  });
};
const fetchCartUpsellProduct = async (handle) => {
  var _a, _b;
  const cachedRequest = cartUpsellProductRequests.get(handle);
  if (cachedRequest) return cachedRequest;
  const routeRoot = ((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/";
  const productUrl = new URL(
    `products/${encodeURIComponent(handle)}.js`,
    new URL(routeRoot, window.location.origin)
  );
  const productRequest = (async () => {
    try {
      const response = await fetch(productUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error2) {
      cartUpsellProductRequests.delete(handle);
      console.error("cart: Error fetching product upsell data:", error2);
      return null;
    }
  })();
  cartUpsellProductRequests.set(handle, productRequest);
  return productRequest;
};
const getSubscriptionLinePricing = (item) => {
  var _a, _b;
  const compareAtPrice = Number(
    (_a = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _a.compare_at_price
  );
  const subscriptionPrice = Number((_b = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _b.price);
  const quantity = Number(item == null ? void 0 : item.quantity);
  const hasCompareAtLinePrice = Number.isFinite(compareAtPrice) && Number.isFinite(quantity);
  const compareAtLinePrice = hasCompareAtLinePrice ? compareAtPrice * quantity : 0;
  if (!hasCompareAtLinePrice || !Number.isFinite(subscriptionPrice)) {
    return { compareAtLinePrice, savings: 0 };
  }
  return {
    compareAtLinePrice,
    savings: Math.max(0, (compareAtPrice - subscriptionPrice) * quantity)
  };
};
const getSubscriptionCompareAtLinePrice = (item) => getSubscriptionLinePricing(item).compareAtLinePrice;
const getSubscriptionSavings = (item) => getSubscriptionLinePricing(item).savings;
const getSubscriptionSavingsTotal = (items) => {
  if (!Array.isArray(items)) return 0;
  let total = 0;
  for (const item of items) {
    total += getSubscriptionSavings(item);
  }
  return total;
};
const settleCartLoading = () => {
  const store2 = Alpine.store("cart");
  const coordinator = getAutomaticGiftCoordinator(store2);
  store2.loading = coordinator.updates > 0 || Boolean(coordinator.pending);
};
document.addEventListener("alpine:init", () => {
  const cartStore = Alpine.store("cart");
  if (!cartStore) return;
  Object.assign(cartStore, {
    getSubscriptionCompareAtLinePrice,
    getSubscriptionSavings,
    getSubscriptionSavingsTotal
  });
});
const cart = {
  debounceTimeouts: /* @__PURE__ */ new Map(),
  getSubscriptionCompareAtLinePrice,
  getSubscriptionSavings,
  getSubscriptionSavingsTotal,
  quickAddController: null,
  isAutomaticGift,
  /**
   * Loads product data and checks whether a cart line qualifies for the configured upsell.
   * @param {CartUpsellItem} item - Cart line to evaluate
   * @param {CartUpsellType} upsellType - Upsell eligibility mode
   * @returns {Promise<boolean>} Whether the cart line is eligible
   */
  async loadCartUpsellEligibility(item, upsellType) {
    if (!(item == null ? void 0 : item.handle) || upsellType === "none") return false;
    const product = await fetchCartUpsellProduct(item.handle);
    return isCartUpsellEligible(item, product, upsellType);
  },
  /**
   * Applies the variant's first subscription plan to the existing cart line.
   * @param {EditableCartItem & { key: string }} item - Cart line to upgrade
   * @param {string} errorMessage - Localized fallback error message
   * @returns {Promise<void>}
   */
  async upgradeCartItemSubscription(item, errorMessage) {
    var _a, _b, _c;
    const cartStore = Alpine.store("cart");
    if (cartStore.loading || item.selling_plan_allocation || !item.key) return;
    cartStore.loading = true;
    try {
      const product = await fetchCartUpsellProduct(item.handle);
      const variant = (_a = product == null ? void 0 : product.variants) == null ? void 0 : _a.find(
        (candidate) => Number(candidate.id) === Number(item.variant_id)
      );
      const sellingPlanId = Number(
        (_c = (_b = variant == null ? void 0 : variant.selling_plan_allocations) == null ? void 0 : _b[0]) == null ? void 0 : _c.selling_plan_id
      );
      if (!Number.isSafeInteger(sellingPlanId) || sellingPlanId <= 0) {
        throw new Error("No subscription plan is available for this variant");
      }
      const root = window.Shopify.routes.root;
      const currentResponse = await fetch(`${root}cart.js`, { cache: "no-store" });
      if (!currentResponse.ok) throw new Error("Could not load the current cart");
      const currentCart = await currentResponse.json();
      const lineIndex = currentCart.items.findIndex(
        (candidate) => candidate.key === item.key
      );
      if (lineIndex < 0) throw new Error("The cart line has changed");
      const currentItem = currentCart.items[lineIndex];
      if (currentItem.selling_plan_allocation) return;
      const response = await fetch(`${root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: lineIndex + 1,
          quantity: currentItem.quantity,
          selling_plan: sellingPlanId
        })
      });
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "subscription" });
        this.showError((data2 == null ? void 0 : data2.description) || errorMessage);
        return;
      }
      await this.updateCart(false, false, { source: "subscription" });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "subscription" });
      this.showError(errorMessage);
      console.error("cart: Error upgrading subscription:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Opens the quick-edit interface for a cart line.
   * @param {EditableCartItem} item - Cart line to edit
   * @param {string} template - Product template used by quick edit
   * @returns {void}
   */
  openCartItemEditor(item, template) {
    var _a, _b;
    const cartStore = Alpine.store("cart");
    cartStore.editQuantity = item.quantity;
    cartStore.editVariantId = item.variant_id;
    cartStore.editSellingPlanId = ((_b = (_a = item.selling_plan_allocation) == null ? void 0 : _a.selling_plan) == null ? void 0 : _b.id) ?? null;
    this.fetchAndRenderProductTemplate(
      item.handle,
      item.variant_id,
      template,
      "[data-quick-edit]",
      () => {
        Alpine.store("config").states.quickEditLoading = true;
      },
      () => {
        Alpine.store("config").states.quickEditLoading = false;
      },
      () => {
        Alpine.store("config").states.quickEditLoading = false;
      }
    );
    this.toggleOverlay("theme__quickedit", false);
  },
  /**
   * Adds a cart item by submitting the product form.
   * @param {HTMLFormElement} form - The product form element to submit
   * @param {boolean} openOverlay - Whether to open the cart drawer after adding
   * @returns {void}
   */
  async submitProductForm(form, openOverlayFromUpdate) {
    var _a, _b;
    if (this.purchaseOffersPending) return;
    const offerSelection = (_a = this.purchaseOfferState) == null ? void 0 : _a.getSelection(this.product, this.selectedVariant);
    if (this.purchaseOfferState && !(offerSelection == null ? void 0 : offerSelection.available)) return;
    if (Alpine.store("cart").loading) return;
    Alpine.store("cart").loading = true;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    const formData = new FormData(form);
    for (const [key, value] of Array.from(formData.entries())) {
      if (key === "selling_plan" && value === "0") {
        formData.delete(key);
      }
    }
    const variantId = Number(formData.get("id"));
    const quantity = Number(formData.get("quantity") || "1");
    (_b = this.purchaseOfferState) == null ? void 0 : _b.appendIncludedProduct(formData, offerSelection == null ? void 0 : offerSelection.includedProduct);
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json"
          }
        }
      );
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "add" });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      if (offerSelection == null ? void 0 : offerSelection.discountCode) {
        try {
          await this.purchaseOfferState.applyOfferDiscount(offerSelection.discountCode);
        } catch (error2) {
          await this.updateCart(openOverlayFromUpdate, false, { source: "add", variantId, quantity });
          this.dispatchEvent("cart:error", { source: "discount" });
          this.showError(offerSelection.discountError);
          console.error("cart: Offer discount failed:", error2);
          return;
        }
      }
      this.playAudioIfEnabled(Alpine.store("config").audio.successWav);
      await this.updateCart(openOverlayFromUpdate, false, { source: "add", variantId, quantity });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "add" });
      console.error("cart: Error in submitProductForm:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Fetches the current cart without publishing store state or reconciling products.
   * @param {string} source - Cart operation reported with request failures
   * @returns {Promise<CartData | undefined>} Current cart, or undefined on failure
   */
  async fetchCart(source = "update") {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      return data2;
    } catch (error2) {
      this.dispatchEvent("cart:error", { source });
      console.error("cart: Error in fetchCart:", error2);
    }
  },
  /**
   * Fetches current cart JSON and updates Alpine store state.
   * @param {boolean} openOverlayFromUpdate - Whether to open the cart UI after update
   * @param {boolean} openOverlayFromButton - Whether to open from button click
   * @param {Object} eventDetail - Additional details to include in the cart:change event
   * @returns {Promise<void>}
   */
  async updateCart(openOverlayFromUpdate, openOverlayFromButton = false, eventDetail = {}) {
    const coordinator = getAutomaticGiftCoordinator(Alpine.store("cart"));
    coordinator.updates += 1;
    Alpine.store("cart").loading = true;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    try {
      let data2 = await this.fetchCart(eventDetail.source || "update");
      if (!data2) return;
      data2 = await coordinator.reconcile(data2, this);
      Alpine.store("cart").hydrated = true;
      Alpine.store("cart").items = data2.items;
      Alpine.store("cart").itemCount = data2.item_count;
      Alpine.store("cart").note = data2.note;
      Alpine.store("cart").totalPrice = data2.total_price;
      Alpine.store("cart").originalTotalPrice = data2.original_total_price;
      Alpine.store("cart").totalDiscount = data2.total_discount;
      Alpine.store("cart").note = typeof data2.note === "string" ? data2.note : "";
      Alpine.store("cart").cartLevelDiscountApplications = data2.cart_level_discount_applications;
      this.sortCartItems();
      if (openOverlayFromUpdate) {
        this.toggleCartOverlayFromCartUpdate();
      }
      if (openOverlayFromButton) {
        this.toggleCartOverlayFromButton();
      }
      this.dispatchEvent("cart:change", {
        source: eventDetail.source || "update",
        cart: Alpine.store("cart").items,
        itemCount: data2.item_count,
        totalPrice: data2.total_price,
        ...eventDetail.variantId && { variantId: eventDetail.variantId },
        ...eventDetail.quantity && { quantity: eventDetail.quantity }
      });
      return data2;
    } catch (error2) {
      this.dispatchEvent("cart:error", {
        source: eventDetail.source || "update"
      });
      console.error("cart: Error in updateCart:", error2);
    } finally {
      coordinator.updates -= 1;
      settleCartLoading();
    }
  },
  /**
   * Updates the cart note via cart/update.js and refreshes cart state.
   * @param {string} note - The note to set on the cart
   * @returns {Promise<void>}
   */
  async updateCartNote(note) {
    Alpine.store("cart").loading = true;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/update.js`,
        {
          method: "POST",
          body: JSON.stringify({ note }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "note" });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      Alpine.store("cart").items = data2.items.map((item) => ({
        ...item
      }));
      Alpine.store("cart").note = typeof data2.note === "string" ? data2.note : "";
      await this.updateCart(false, false, { source: "note" });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "note" });
      console.error("cart: Error in updateCartNote:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Adds a single variant to the cart via cart/add.js.
   * @param {number} variantId - The variant ID to add
   * @param {number} sellingPlanId - The selling plan ID (0 for none)
   * @param {number} quantity - Quantity to add
   * @param {boolean} openOverlay - Whether to open the cart UI after add
   * @param {Object} options - Optional line properties and store update behavior
   * @returns {Promise<any>} Fetch promise resolving after cart update
   */
  async addCartItem(variantId, sellingPlanId, quantity, openOverlayFromUpdate, options = {}) {
    Alpine.store("cart").loading = true;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    const item = sellingPlanId === 0 ? { items: [{ id: variantId, quantity }] } : { items: [{ id: variantId, quantity, selling_plan: sellingPlanId }] };
    if (options.properties)
      Object.assign(item.items[0], { properties: options.properties });
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        body: JSON.stringify(item),
        headers: {
          "Content-Type": "application/json"
        }
      });
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "add" });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      this.playAudioIfEnabled(Alpine.store("config").audio.successWav);
      if (options.updateCart === false) return await this.fetchCart();
      return await this.updateCart(openOverlayFromUpdate, false, {
        source: "add",
        variantId,
        quantity
      });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "add" });
      console.error("cart: Error in addCartItem:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Adds multiple items to the cart sequentially, then opens the cart.
   * @param {Array<{variantId:number, quantity:number}>} items - Items to add
   * @returns {Promise<void>}
   */
  async addCartItems(items) {
    if (!Array.isArray(items) || items.length === 0) return;
    Alpine.store("cart").loading = true;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    let succeeded = 0;
    let failed = 0;
    try {
      for (const item of items) {
        const isValid = item && Number.isFinite(item.variantId) && Number.isFinite(item.quantity) && item.quantity > 0;
        if (!isValid) {
          failed += 1;
          continue;
        }
        try {
          await this.addCartItem(
            item.variantId,
            0,
            item.quantity,
            false
          );
          succeeded += 1;
        } catch (error2) {
          this.dispatchEvent("cart:error", { source: "add-multiple" });
          console.error("cart: Error in addCartItems:", error2);
          failed += 1;
        }
      }
      if (succeeded > 0) {
        this.playAudioIfEnabled(Alpine.store("config").audio.successWav);
        await this.updateCart(false, true, { source: "add-multiple" });
      }
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Applies one or more discount codes to the cart.
   * @param {string} inputId - The DOM id of the discount code input element
   * @returns {Promise<any | null>} Resolves with cart JSON on success, otherwise null
   */
  async applyDiscountCode(inputId) {
    var _a;
    const input = document.getElementById(inputId);
    if (!input) {
      console.error(`Input element with ID '${inputId}' not found`);
      return null;
    }
    const inputValue = (_a = input.value) == null ? void 0 : _a.trim();
    if (!inputValue) return null;
    const codes = inputValue.split(",").map((code) => code.trim()).filter((code) => code.length > 0);
    const uniqueCodes = Array.from(new Set(codes));
    if (uniqueCodes.length === 0) return null;
    const discountCodesString = uniqueCodes.join(",");
    Alpine.store("cart").loading = true;
    input.disabled = true;
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/update.js`,
        {
          method: "POST",
          body: JSON.stringify({ discount: discountCodesString }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "discount" });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      input.value = "";
      await this.updateCart(false, false, { source: "discount" });
      return data2;
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "discount" });
      console.error("cart: Error in applyDiscountCode:", error2);
      return;
    } finally {
      settleCartLoading();
      input.disabled = false;
    }
  },
  /**
   * Replaces an existing cart line by removing the old variant and adding a new one.
   * Extracts variant ID, quantity, and selling plan from the form data.
   * @param {HTMLFormElement} form - The form element containing the new item data
   * @returns {Promise<void>}
   */
  async editCartItem(form) {
    Alpine.store("cart").loading = true;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    const formData = new FormData(form);
    for (const [key, value] of Array.from(formData.entries())) {
      if (key === "selling_plan" && value === "0") {
        formData.delete(key);
      }
    }
    const removePayload = {
      id: Alpine.store("cart").editVariantId.toString(),
      quantity: "0"
    };
    try {
      const removeResponse = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          body: JSON.stringify(removePayload),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      const removeData = await removeResponse.json();
      if (!removeResponse.ok) {
        this.dispatchEvent("cart:error", { source: "edit" });
        this.showError(removeData == null ? void 0 : removeData.description);
        return;
      }
      const addResponse = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json"
          }
        }
      );
      const addData = await addResponse.json();
      if (!addResponse.ok) {
        this.dispatchEvent("cart:error", { source: "edit" });
        this.showError(addData == null ? void 0 : addData.description);
        return;
      }
      this.playAudioIfEnabled(Alpine.store("config").audio.successWav);
      const variantId = Number(formData.get("id"));
      const quantity = Number(formData.get("quantity") || "1");
      await this.updateCart(false, false, { source: "edit", variantId, quantity });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "edit" });
      console.error("cart: Error in editCartItem:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Removes multiple cart lines in one cart update.
   * @param {Array<string | number>} keys - Cart line keys to remove
   * @param {Object} options - Whether to publish and reconcile the updated cart
   * @returns {Promise<void>}
   */
  async removeCartItems(keys, options = {}) {
    const updates = {};
    for (const key of keys) {
      const lineKey = String(key).trim();
      if (lineKey) updates[lineKey] = 0;
    }
    if (Object.keys(updates).length === 0) return;
    Alpine.store("cart").loading = true;
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/update.js`,
        {
          method: "POST",
          body: JSON.stringify({ updates }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "change" });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      this.playAudioIfEnabled(Alpine.store("config").audio.successWav);
      if (options.updateCart === false) return data2;
      return await this.updateCart(false, false, { source: "change", quantity: 0 });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "change" });
      console.error("cart: Error in removeCartItems:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Updates a cart line's quantity via cart/change.js, with optional UI behaviors.
   * @param {number} key - The cart line item key
   * @param {number} quantity - The new quantity to set
   * @param {boolean} openOverlay - Whether to open the cart UI after update
   * @param {boolean} refresh - If true, reloads the page instead of updating client state
   * @returns {Promise<void>}
   */
  async changeCartItemQuantity(key, quantity, openOverlayFromUpdate, refresh) {
    Alpine.store("cart").loading = true;
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    const payload = {
      id: String(key),
      quantity: String(quantity)
    };
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      const data2 = await response.json();
      if (!response.ok) {
        this.dispatchEvent("cart:error", { source: "change" });
        this.showError(data2 == null ? void 0 : data2.description);
        return;
      }
      if (refresh) {
        window.location.reload();
        return;
      }
      this.playAudioIfEnabled(Alpine.store("config").audio.successWav);
      await this.updateCart(openOverlayFromUpdate, false, { source: "change", quantity });
    } catch (error2) {
      this.dispatchEvent("cart:error", { source: "change" });
      console.error("cart: Error in changeCartItemQuantity:", error2);
    } finally {
      settleCartLoading();
    }
  },
  /**
   * Builds product groups, individual cart rows, and cart summary aggregates.
   * Populates `Alpine.store("cart").summary`, `groupedItems`, and `ungroupedItems`.
   * @returns {void}
   */
  sortCartItems() {
    var _a, _b;
    const cartStore = Alpine.store("cart");
    const items = cartStore.items;
    const summary = {};
    const grouped = {};
    const ungrouped = {};
    for (const item of items) {
      const s = summary[_a = item.product_id] ?? (summary[_a] = {
        product_title: item.product_title,
        quantity: 0,
        total_final_line_price: 0
      });
      s.quantity += item.quantity;
      s.total_final_line_price += item.final_line_price;
      const g = grouped[_b = item.product_id] ?? (grouped[_b] = {
        product_title: item.product_title,
        title: item.product_title,
        featured_image: item.featured_image,
        handle: item.handle,
        product_has_only_default_variant: item.product_has_only_default_variant,
        url: item.url,
        items: []
      });
      g.items.push(item);
      ungrouped[item.key] = {
        ...g,
        title: item.variant_title && !item.product_has_only_default_variant ? `${item.product_title} ${item.variant_title}` : item.product_title,
        featured_image: item.featured_image,
        url: item.url,
        items: [item]
      };
    }
    cartStore.summary = summary;
    cartStore.groupedItems = grouped;
    cartStore.ungroupedItems = ungrouped;
  },
  /**
   * Displays a discount alert when URL contains a discount text query parameter.
   * Safely waits for Alpine.js store to be available before showing the alert.
   * @example URL: example.com/discount/13KS94BNGCS8?dt=Save+20%25+storewide
   */
  handleSharedDiscount() {
    const discountCode = this.getCookie("discount_code") || "";
    const url = new URL(window.location.href);
    const discountText = url.searchParams.get("dt");
    if (!discountText) return;
    const MAX_RETRIES = 20;
    const DELAY_MS = 100;
    let retryCount = 0;
    const isAlpineReady = () => typeof Alpine !== "undefined";
    const isOverlayReady = () => {
      try {
        const overlays = Alpine.store("overlays");
        return overlays && overlays["theme__discount"];
      } catch (_) {
        return false;
      }
    };
    const checkAndShowAlert = () => {
      if (retryCount++ >= MAX_RETRIES) {
        console.warn(
          "Failed to show discount alert: Alpine or overlay not ready after multiple attempts"
        );
        return;
      }
      if (!isAlpineReady() || !isOverlayReady()) {
        setTimeout(checkAndShowAlert, DELAY_MS);
        return;
      }
      try {
        Alpine.store("feedback").discount = { code: discountCode, text: discountText };
        this.openOverlay("theme__discount", true);
      } catch (error2) {
        console.error("Error showing discount alert:", error2);
      }
    };
    checkAndShowAlert();
  },
  /**
   * Parses cartshare parameters from the URL and adds the specified items to the cart.
   * Clears the cart before adding shared cart items.
   * @returns {Promise<void>}
   */
  async handleSharedCart() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("cartshare")) return;
    const items = [];
    for (const [key, raw2] of url.searchParams.entries()) {
      if (key !== "id" || !raw2) continue;
      const nested = new URLSearchParams(`id=${raw2.replace(",", "&")}`);
      const idParam = nested.get("id");
      const qtyParam = nested.get("q");
      const variantId = idParam ? Number(idParam) : NaN;
      const quantity = qtyParam ? Number(qtyParam) : 1;
      if (Number.isFinite(variantId) && variantId > 0 && Number.isFinite(quantity) && quantity > 0) {
        items.push({ variantId, quantity });
      }
    }
    if (items.length) {
      await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      await this.addCartItems(items);
    }
  }
};
const utils = {
  // INIT
  /**
   * Refreshes the page when using the back button if history states were changed.
   * @returns {void}
   */
  initPopstate() {
    window.addEventListener("popstate", async () => {
      window.location.href = location.href;
    });
  },
  // HANDLE UI UPDATES
  /**
   * Handles body scrolling and updates scroll-related states.
   * @returns {void}
   */
  handleBodyScroll() {
    try {
      let isExecuting = false;
      if (isExecuting) return;
      isExecuting = true;
      setTimeout(() => {
        try {
          const currentScroll = window.scrollY;
          const scrollThreshold = 200;
          const minScrollDifference = 50;
          if (currentScroll > scrollThreshold) {
            Alpine.store("config").states.isScrolledUp = false;
            if (Math.abs(
              currentScroll - Alpine.store("config").states.prevScrollPos
            ) > minScrollDifference) {
              Alpine.store("config").states.isScrolled = currentScroll > Alpine.store("config").states.prevScrollPos;
            }
            if (Alpine.store("config").states.hasHeaderOverlap) {
              Alpine.store("config").header.color = Alpine.store("config").header.defaultColor;
              Alpine.store("config").header.border = Alpine.store("config").header.defaultBorder;
            }
          } else {
            Alpine.store("config").states.isScrolledUp = true;
            Alpine.store("config").states.isScrolled = false;
            if (Alpine.store("config").states.hasHeaderOverlap) {
              Alpine.store("config").header.color = Alpine.store("config").header.overlayColor;
              Alpine.store("config").header.border = Alpine.store("config").header.overlayBorder;
            }
          }
          Alpine.store("config").states.prevScrollPos = currentScroll;
          isExecuting = false;
        } catch (error2) {
          console.error("utils: Error in handleBodyScroll setTimeout:", error2);
        }
      }, 100);
    } catch (error2) {
      console.error("utils: Error in handleBodyScroll:", error2);
    }
  },
  /**
   * Checks if the URL contains 'account' and opens the account drawer if true.
   * @returns {void}
   */
  handleOpnedAccount() {
    if (location.search.includes("?account")) {
      this.toggleOverlay("theme__account");
    }
  },
  /**
   * Adds 'loaded' classes to images and their containers after loading.
   * @returns {void}
   */
  loadImages() {
    try {
      const loadImage = (img) => {
        var _a, _b;
        img.classList.add("loaded");
        (_b = (_a = img.parentElement) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.classList.add("loaded");
      };
      const images = document.querySelectorAll("[data-picture] img");
      for (const img of images) {
        const imageElement = img;
        setTimeout(() => {
          if (imageElement.complete) {
            loadImage(imageElement);
          } else {
            imageElement.onload = () => {
              loadImage(imageElement);
            };
          }
        }, 300);
        setTimeout(() => {
          loadImage(imageElement);
        }, 2e3);
      }
    } catch (error2) {
      console.error("utils: Error in loadImages:", error2);
    }
  },
  /**
   * Assigns staggered delays to load animations and starts them.
   * @returns {void}
   */
  initLoadAnimations() {
    try {
      const loadAnimationElements = Array.from(
        document.querySelectorAll("[data-load-animation]")
      );
      if (!loadAnimationElements.length) return;
      const enhancedElements = [];
      let offsetIndex = 0;
      for (const item of loadAnimationElements) {
        if (!(item instanceof HTMLElement)) continue;
        const loadAnimation = item.dataset.loadAnimation || "";
        if (loadAnimation.endsWith("-offset")) {
          item.style.setProperty("--load-delay", `${offsetIndex * 150}ms`);
          offsetIndex += 1;
        }
        enhancedElements.push(item);
      }
      window.requestAnimationFrame(() => {
        for (const element of enhancedElements) {
          element.dataset.loadAnimationReady = "true";
        }
      });
    } catch (error2) {
      console.error("utils: Error in initLoadAnimations:", error2);
    }
  },
  // USER ERRORS AND EVENTS
  /**
   * Shows an error message in the feedback store and opens the error overlay.
   * @param {string} message - The error message to show.
   * @returns {void}
   */
  showError(message) {
    Alpine.store("feedback").error.message = message;
    this.openOverlay("theme__error");
  },
  /**
   * Dispatches a custom event with the given name and detail.
   * @param {string} name - The name of the event.
   * @param {any} [detail={}] - Additional data to pass with the event.
   * @returns {void}
   */
  dispatchEvent(name, detail = {}) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  },
  // USER ACTIONS
  /**
   * Copies the value of an input element to the clipboard and focuses the element.
   * @param {string} id - The ID of the input element.
   * @returns {void}
   */
  copyToClipboard(id) {
    const copyText = document.getElementById(id);
    if (copyText) {
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      try {
        navigator.clipboard.writeText(copyText.value);
      } catch (err) {
        console.error("utils: Failed to copy text:", err);
      }
    } else {
      console.error("utils: Element not found:", id);
    }
  },
  /**
   * Plays an audio file if audio is enabled in the configuration.
   * @param {string} audioFile - The path to the audio file.
   * @returns {void}
   */
  playAudioIfEnabled(audioFile) {
    if (Alpine.store("config").toggles.enableAudio) {
      const audio = new Audio(audioFile);
      if (window.innerWidth > 768) {
        audio.play();
      }
    }
  },
  /**
   * Opens an overlay and optionally disables auto-close.
   * @param {string} overlay - The overlay identifier.
   * @param {boolean} [disableAutoClose=false] - Whether to disable auto-close.
   * @returns {void}
   */
  openOverlay(overlay, disableAutoClose = false) {
    const overlayObject = Alpine.store("overlays")[overlay];
    if (!overlayObject) {
      console.warn(`utils: Overlay '${overlay}' not found`);
      return;
    }
    this.closeAllOverlays();
    this._configureOverlayType(overlayObject);
    this._updateOverlayStore(overlay, disableAutoClose);
    const overlayElements = document.querySelectorAll(".overlay-" + overlay);
    for (const element of overlayElements) {
      const overlayElement = element;
      this._clearScheduledPopoverHide(overlayElement);
      overlayElement.showPopover();
    }
  },
  /**
   * Closes an overlay.
   * @param {string} overlay - The overlay identifier.
   * @returns {void}
   */
  closeOverlay(overlay) {
    const overlays = Alpine.store("overlays") || {};
    const hasActiveSidebar = Object.values(overlays).some(
      (overlay2) => (overlay2 == null ? void 0 : overlay2.type) === "sidebar" && overlay2.status
    );
    Alpine.store("config").states.hasVisibleSidebar = hasActiveSidebar;
    Alpine.store("config").toggles.enableBodyScrolling = true;
    const overlayObject = Alpine.store("overlays")[overlay];
    if (!overlayObject) {
      console.warn(`utils: Overlay '${overlay}' not found`);
      return;
    }
    overlayObject.status = false;
    const overlayElements = document.querySelectorAll(".overlay-" + overlay);
    for (const element of overlayElements) {
      const el = element;
      if (el.matches(":popover-open")) {
        this._hidePopoverWithLeaveTransition(el);
      }
    }
  },
  /**
   * Closes all overlays and resets related states.
   * @returns {void}
   */
  closeAllOverlays(force = false) {
    var _a;
    if (!force && Alpine.store("config").states.hasUnescapeableOverlay) {
      return;
    }
    const overlays = Alpine.store("overlays") || {};
    const hasActiveSidebar = Object.values(overlays).some(
      (overlay) => (overlay == null ? void 0 : overlay.type) === "sidebar" && overlay.status
    );
    Alpine.store("config").toggles.enableBodyScrolling = true;
    const currentTimeout = (_a = Alpine.store("overlay_delay")) == null ? void 0 : _a.timeout;
    if (currentTimeout) {
      clearTimeout(currentTimeout);
    }
    Alpine.store("config").delay = {
      ...Alpine.store("config").delay,
      width: "0%",
      timeout: null
    };
    for (const key of Object.keys(overlays)) {
      const overlayConfig = overlays[key];
      if (!overlayConfig || overlayConfig.type === "sidebar") {
        continue;
      }
      const overlayElements = document.querySelectorAll(".overlay-" + key);
      for (const element of overlayElements) {
        const el = element;
        if (el.matches(":popover-open")) {
          this._hidePopoverWithLeaveTransition(el);
        }
      }
      overlays[key] = {
        ...overlayConfig,
        status: false
      };
    }
    Alpine.store("overlays", overlays);
    Alpine.store("config").states.hasVisibleSidebar = hasActiveSidebar;
    Alpine.store("config").states.hasUnescapeableOverlay = false;
  },
  /**
   * Opens an overlay and optionally disables auto-close.
   * @param {string} message - The message to update the form response.
   * @param {string} status - The status to update the form response.
   * @returns {void}
   */
  updateAndOpenFormResponse(message, status) {
    Alpine.store("feedback").form.message = message;
    Alpine.store("feedback").form.status = status;
    this.openOverlay("theme__formresponse");
  },
  /**
   * Toggles the visibility of an overlay.
   * @param {string} overlay - The overlay identifier.
   * @param {boolean} [enableAutoClose=true] - Whether to enable auto-close for the overlay.
   * @returns {void}
   */
  toggleOverlay(overlay, enableAutoClose = true) {
    try {
      const currentOverlay = Alpine.store("overlays")[overlay];
      const currentOverlayStatus = currentOverlay.status;
      this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
      if (enableAutoClose) {
        this.closeAllOverlays();
      }
      if (currentOverlay.type === "popup" || currentOverlay.type === "drawer") {
        const overlayElements = document.querySelectorAll(".overlay-" + overlay);
        Alpine.store("overlays")[overlay].status = !currentOverlayStatus;
        Alpine.store("config").toggles.enableBodyScrolling = currentOverlayStatus;
        for (const element of overlayElements) {
          const overlayElement = element;
          if (!currentOverlayStatus) {
            this._clearScheduledPopoverHide(overlayElement);
            overlayElement.showPopover();
          } else {
            this._hidePopoverWithLeaveTransition(overlayElement);
          }
        }
      }
      if (currentOverlay.type === "sidebar") {
        const overlayElements = document.querySelectorAll(".overlay-" + overlay);
        Alpine.store("overlays")[overlay].status = !currentOverlayStatus;
        const overlays = Alpine.store("overlays") || {};
        const hasActiveSidebar = Object.values(overlays).some(
          (overlay2) => (overlay2 == null ? void 0 : overlay2.type) === "sidebar" && overlay2.status
        );
        Alpine.store("config").states.hasVisibleSidebar = hasActiveSidebar;
        Alpine.store("config").toggles.enableBodyScrolling = true;
        if (!currentOverlayStatus) {
          Alpine.store("config").states.sidebarPosition = currentOverlay.position;
          for (const element of overlayElements) {
            const overlayElement = element;
            this._clearScheduledPopoverHide(overlayElement);
            overlayElement.showPopover();
          }
        } else {
          for (const element of overlayElements) {
            this._hidePopoverWithLeaveTransition(element);
          }
        }
      }
      if (currentOverlay.type === "alert") {
        const overlayElements = document.querySelectorAll(".overlay-" + overlay);
        if (currentOverlayStatus) {
          Alpine.store("overlays")[overlay].status = false;
          Alpine.store("config").toggles.enableBodyScrolling = true;
        } else {
          Alpine.store("overlays")[overlay].status = true;
          Alpine.store("config").toggles.enableBodyScrolling = true;
        }
        for (const element of overlayElements) {
          const overlayElement = element;
          if (!currentOverlayStatus) {
            this._clearScheduledPopoverHide(overlayElement);
            overlayElement.showPopover();
          } else {
            this._hidePopoverWithLeaveTransition(overlayElement);
          }
        }
      }
    } catch (error2) {
      console.error("utils: Error in toggleOverlay:", error2);
    }
  },
  /**
   * Toggles the account overlay from a button click.
   * @returns {void}
   */
  toggleAccountOverlayFromButton() {
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    this.toggleOverlay("theme__account");
  },
  /**
   * Toggles the cart overlay based on the cart button settings.
   * @returns {void}
   */
  toggleCartOverlayFromButton() {
    this.playAudioIfEnabled(Alpine.store("config").audio.clickWav);
    if (Alpine.store("config").behavior.cartButton === "primary") {
      this.toggleOverlay("theme__cartprimary");
    }
    if (Alpine.store("config").behavior.cartButton === "alternative") {
      this.toggleOverlay("theme__cartalternative");
    }
    if (Alpine.store("config").behavior.cartButton === "redirectcart") {
      window.location.href = "/cart";
    }
    if (Alpine.store("config").behavior.cartButton === "redirectcheckout") {
      window.location.href = "/checkout";
    }
  },
  /**
   * Toggles the cart overlay based on cart updates.
   * @returns {void}
   */
  toggleCartOverlayFromCartUpdate() {
    let cartBehavior;
    const cartOverlays = ["theme__cartalternative", "theme__cartprimary"];
    const isAnyCartOverlayOpen = cartOverlays.some((overlay) => Alpine.store("overlays")[overlay].status);
    if (isAnyCartOverlayOpen) {
      return;
    }
    if (window.innerWidth < 768) {
      cartBehavior = Alpine.store("config").behavior.cartMobile;
      if (cartBehavior === "alternative") {
        this.openOverlay("theme__cartalternative");
      }
      if (cartBehavior === "primary") {
        this.openOverlay("theme__cartprimary");
      }
    } else {
      cartBehavior = Alpine.store("config").behavior.cartDesktop;
      if (cartBehavior === "alternative") {
        this.openOverlay("theme__cartalternative");
      }
      if (cartBehavior === "primary") {
        this.openOverlay("theme__cartprimary");
      }
    }
    if (cartBehavior === "redirectcart") {
      window.location.href = "/cart";
    }
    if (cartBehavior === "redirectcheckout") {
      window.location.href = "/checkout";
    }
  },
  /**
   * Configures the overlay type by updating the configuration store based on the overlay type.
   * @param {{ type: 'popup' | 'drawer' | 'sidebar' | 'alert', position?: string, status?: boolean }} overlayObject - The overlay object containing type and other properties.
   * @returns {void}
   */
  _configureOverlayType(overlayObject) {
    const configStore = Alpine.store("config");
    switch (overlayObject.type) {
      case "popup":
      case "drawer":
        configStore.toggles.enableBodyScrolling = false;
        break;
      case "sidebar":
        configStore.states.hasVisibleSidebar = true;
        configStore.states.sidebarPosition = overlayObject.position;
        break;
    }
  },
  /**
   * Updates the overlay store with the given overlay identifier and auto-close setting.
   * @param {string} overlay - The overlay identifier.
   * @param {boolean} disableAutoClose - Whether to disable auto-close for the overlay.
   * @returns {void}
   */
  _updateOverlayStore(overlay, disableAutoClose) {
    const overlays = Alpine.store("overlays");
    overlays[overlay] = {
      ...overlays[overlay],
      status: true,
      disableAutoClose
    };
    Alpine.store("overlays", overlays);
  },
  /**
   * Clears any scheduled popover hide timeout on the provided element.
   * @param {HTMLElement} element - The overlay element to clear from pending hides.
   * @returns {void}
   */
  _clearScheduledPopoverHide(element) {
    var _a;
    const hideTimeoutId = (_a = element == null ? void 0 : element.dataset) == null ? void 0 : _a.overlayHideTimeoutId;
    if (hideTimeoutId) {
      window.clearTimeout(Number(hideTimeoutId));
      delete element.dataset.overlayHideTimeoutId;
    }
  },
  /**
   * Schedules hiding a popover element after its leave transition completes.
   * @param {HTMLElement} element - The overlay element to hide.
   * @returns {void}
   */
  _hidePopoverWithLeaveTransition(element) {
    var _a;
    const overlayLeaveDuration = 300;
    try {
      if (!element || !element.matches(":popover-open")) {
        return;
      }
      this._clearScheduledPopoverHide(element);
      const timeoutId = window.setTimeout(() => {
        if (element.matches(":popover-open")) {
          element.hidePopover();
        }
        delete element.dataset.overlayHideTimeoutId;
      }, overlayLeaveDuration);
      element.dataset.overlayHideTimeoutId = timeoutId.toString();
    } catch (error2) {
      console.error("utils: Error scheduling popover hide:", error2);
      (_a = element == null ? void 0 : element.hidePopover) == null ? void 0 : _a.call(element);
    }
  },
  // PURE UTILITY
  /**
   * Converts a string to a handle format, matching the Liquid handle filter.
   * @param {string} str - The string to convert.
   * @returns {string} The handleized string.
   */
  handleize(str) {
    return str.toLowerCase().replace(/['"]+/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").replace(/-+/g, "-");
  },
  /**
   * Encodes a string to base64 format.
   * @param {string} str - The string to encode.
   * @returns {string} The base64 encoded string.
   */
  encodeToBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
  },
  /**
   * Retrieves a cookie value by its name.
   * @param {string} name - The name of the cookie.
   * @returns {string | null} The cookie value or null if not found.
   */
  getCookie(name) {
    const cookieMatch = document.cookie.match(
      "(^|;)\\s*" + name + "\\s*=\\s*([^;]+)"
    );
    return cookieMatch ? cookieMatch.pop() : null;
  }
};
const defaultOption = (opt, def) => {
  return typeof opt === "undefined" ? def : opt;
};
const formatWithDelimiters = (valueInCents, precision, thousands, decimal) => {
  const usePrecision = defaultOption(precision, 2);
  const thousandsSep = defaultOption(thousands, ",");
  const decimalSep = defaultOption(decimal, ".");
  const absolute = Math.abs(valueInCents);
  const sign = valueInCents < 0 ? "-" : "";
  const number = (absolute / 100).toFixed(usePrecision);
  const parts = number.split(".");
  const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousandsSep);
  const centsPart = parts[1] ? decimalSep + parts[1] : "";
  return sign + dollars + centsPart;
};
const getFormatString = (forceEnableCurrency, showCurrency, formatStringWithCurrency, formatStringWithoutCurrency) => {
  if (forceEnableCurrency === true) {
    return formatStringWithCurrency;
  }
  if (forceEnableCurrency === false) {
    return formatStringWithoutCurrency;
  }
  return showCurrency ? formatStringWithCurrency : formatStringWithoutCurrency;
};
const getFormattedValue = (token, cents) => {
  switch (token) {
    case "amount":
      return formatWithDelimiters(cents, 2);
    case "amount_no_decimals":
      return formatWithDelimiters(cents, 0);
    case "amount_with_comma_separator":
      return formatWithDelimiters(cents, 2, ".", ",");
    case "amount_no_decimals_with_comma_separator":
      return formatWithDelimiters(cents, 0, ".", ",");
    default:
      return formatWithDelimiters(cents, 2);
  }
};
const formatMoney = (cents, forceEnableCurrency, forceEnableZeros) => {
  try {
    const normalizedCents = typeof cents === "string" ? Number(cents.replace(".", "")) : Number(cents);
    if (!Number.isFinite(normalizedCents)) {
      return "";
    }
    const hasAlpineStore = typeof Alpine !== "undefined" && typeof Alpine.store === "function";
    const config = hasAlpineStore ? Alpine.store("config") : null;
    const prices = (config == null ? void 0 : config.prices) ?? {};
    const toggles = (config == null ? void 0 : config.toggles) ?? {};
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatStringWithCurrency = prices.format_without_currency || "${{amount}} CAD";
    const formatStringWithoutCurrency = prices.format_with_currency || "${{amount}}";
    const enableZeros = forceEnableZeros ?? (typeof toggles.enable_zeros === "boolean" ? toggles.enable_zeros : true);
    const showCurrency = typeof toggles.show_currency_symbol === "boolean" ? toggles.show_currency_symbol : false;
    const formatString = getFormatString(
      forceEnableCurrency,
      showCurrency,
      formatStringWithCurrency,
      formatStringWithoutCurrency
    );
    const match = formatString.match(placeholderRegex);
    const token = match ? match[1] : "amount";
    const formattedValue = getFormattedValue(token, normalizedCents);
    const value = enableZeros === false ? formattedValue.replace(/[.,]00$/, "") : formattedValue;
    const output = formatString.replace(placeholderRegex, value);
    return output;
  } catch (error2) {
    console.error("Shopify: Error in formatMoney:", error2);
    return "";
  }
};
const ShopifyGlobal = window.Shopify || {};
ShopifyGlobal.formatMoney = formatMoney;
window.Shopify = ShopifyGlobal;
const Shopify = ShopifyGlobal;
utils.initLoadAnimations();
utils.loadImages();
window.app = function() {
  return {
    ...products,
    ...cart,
    ...utils,
    ...Shopify
  };
};
var instantpage = {};
/*! instant.page v5.2.0 - (C) 2019-2023 Alexandre Dieulot - https://instant.page/license */
var hasRequiredInstantpage;
function requireInstantpage() {
  if (hasRequiredInstantpage) return instantpage;
  hasRequiredInstantpage = 1;
  let _chromiumMajorVersionInUserAgent = null, _allowQueryString, _allowExternalLinks, _useWhitelist, _delayOnHover = 65, _lastTouchTimestamp, _mouseoverTimer, _preloadedList = /* @__PURE__ */ new Set();
  const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
  init();
  function init() {
    const isSupported = document.createElement("link").relList.supports("prefetch");
    if (!isSupported) {
      return;
    }
    const handleVaryAcceptHeader = "instantVaryAccept" in document.body.dataset || "Shopify" in window;
    const chromiumUserAgentIndex = navigator.userAgent.indexOf("Chrome/");
    if (chromiumUserAgentIndex > -1) {
      _chromiumMajorVersionInUserAgent = parseInt(navigator.userAgent.substring(chromiumUserAgentIndex + "Chrome/".length));
    }
    if (handleVaryAcceptHeader && _chromiumMajorVersionInUserAgent && _chromiumMajorVersionInUserAgent < 110) {
      return;
    }
    const mousedownShortcut = "instantMousedownShortcut" in document.body.dataset;
    _allowQueryString = "instantAllowQueryString" in document.body.dataset;
    _allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;
    _useWhitelist = "instantWhitelist" in document.body.dataset;
    const eventListenersOptions = {
      capture: true,
      passive: true
    };
    let useMousedown = false;
    let useMousedownOnly = false;
    let useViewport = false;
    if ("instantIntensity" in document.body.dataset) {
      const intensity = document.body.dataset.instantIntensity;
      if (intensity.startsWith("mousedown")) {
        useMousedown = true;
        if (intensity == "mousedown-only") {
          useMousedownOnly = true;
        }
      } else if (intensity.startsWith("viewport")) {
        const isNavigatorConnectionSaveDataEnabled = navigator.connection && navigator.connection.saveData;
        const isNavigatorConnectionLike2g = navigator.connection && navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g");
        if (!isNavigatorConnectionSaveDataEnabled && !isNavigatorConnectionLike2g) {
          if (intensity == "viewport") {
            if (document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4) {
              useViewport = true;
            }
          } else if (intensity == "viewport-all") {
            useViewport = true;
          }
        }
      } else {
        const milliseconds = parseInt(intensity);
        if (!isNaN(milliseconds)) {
          _delayOnHover = milliseconds;
        }
      }
    }
    if (!useMousedownOnly) {
      document.addEventListener("touchstart", touchstartListener, eventListenersOptions);
    }
    if (!useMousedown) {
      document.addEventListener("mouseover", mouseoverListener, eventListenersOptions);
    } else if (!mousedownShortcut) {
      document.addEventListener("mousedown", mousedownListener, eventListenersOptions);
    }
    if (mousedownShortcut) {
      document.addEventListener("mousedown", mousedownShortcutListener, eventListenersOptions);
    }
    if (useViewport) {
      let requestIdleCallbackOrFallback = window.requestIdleCallback;
      if (!requestIdleCallbackOrFallback) {
        requestIdleCallbackOrFallback = (callback) => {
          callback();
        };
      }
      requestIdleCallbackOrFallback(function observeIntersection() {
        const intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const anchorElement = entry.target;
              intersectionObserver.unobserve(anchorElement);
              preload2(anchorElement.href);
            }
          });
        });
        document.querySelectorAll("a").forEach((anchorElement) => {
          if (isPreloadable(anchorElement)) {
            intersectionObserver.observe(anchorElement);
          }
        });
      }, {
        timeout: 1500
      });
    }
  }
  function touchstartListener(event2) {
    _lastTouchTimestamp = performance.now();
    const anchorElement = event2.target.closest("a");
    if (!isPreloadable(anchorElement)) {
      return;
    }
    preload2(anchorElement.href, "high");
  }
  function mouseoverListener(event2) {
    if (performance.now() - _lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
      return;
    }
    if (!("closest" in event2.target)) {
      return;
    }
    const anchorElement = event2.target.closest("a");
    if (!isPreloadable(anchorElement)) {
      return;
    }
    anchorElement.addEventListener("mouseout", mouseoutListener, { passive: true });
    _mouseoverTimer = setTimeout(() => {
      preload2(anchorElement.href, "high");
      _mouseoverTimer = void 0;
    }, _delayOnHover);
  }
  function mousedownListener(event2) {
    const anchorElement = event2.target.closest("a");
    if (!isPreloadable(anchorElement)) {
      return;
    }
    preload2(anchorElement.href, "high");
  }
  function mouseoutListener(event2) {
    if (event2.relatedTarget && event2.target.closest("a") == event2.relatedTarget.closest("a")) {
      return;
    }
    if (_mouseoverTimer) {
      clearTimeout(_mouseoverTimer);
      _mouseoverTimer = void 0;
    }
  }
  function mousedownShortcutListener(event2) {
    if (performance.now() - _lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
      return;
    }
    const anchorElement = event2.target.closest("a");
    if (event2.which > 1 || event2.metaKey || event2.ctrlKey) {
      return;
    }
    if (!anchorElement) {
      return;
    }
    anchorElement.addEventListener("click", function(event3) {
      if (event3.detail == 1337) {
        return;
      }
      event3.preventDefault();
    }, { capture: true, passive: false, once: true });
    const customEvent = new MouseEvent("click", { view: window, bubbles: true, cancelable: false, detail: 1337 });
    anchorElement.dispatchEvent(customEvent);
  }
  function isPreloadable(anchorElement) {
    if (!anchorElement || !anchorElement.href) {
      return;
    }
    if (_useWhitelist && !("instant" in anchorElement.dataset)) {
      return;
    }
    if (anchorElement.origin != location.origin) {
      let allowed = _allowExternalLinks || "instant" in anchorElement.dataset;
      if (!allowed || !_chromiumMajorVersionInUserAgent) {
        return;
      }
    }
    if (!["http:", "https:"].includes(anchorElement.protocol)) {
      return;
    }
    if (anchorElement.protocol == "http:" && location.protocol == "https:") {
      return;
    }
    if (!_allowQueryString && anchorElement.search && !("instant" in anchorElement.dataset)) {
      return;
    }
    if (anchorElement.hash && anchorElement.pathname + anchorElement.search == location.pathname + location.search) {
      return;
    }
    if ("noInstant" in anchorElement.dataset) {
      return;
    }
    return true;
  }
  function preload2(url, fetchPriority = "auto") {
    if (_preloadedList.has(url)) {
      return;
    }
    const linkElement = document.createElement("link");
    linkElement.rel = "prefetch";
    linkElement.href = url;
    linkElement.fetchPriority = fetchPriority;
    linkElement.as = "document";
    document.head.appendChild(linkElement);
    _preloadedList.add(url);
  }
  return instantpage;
}
requireInstantpage();
var flushPending = false;
var flushing = false;
var queue = [];
var lastFlushedIndex = -1;
function scheduler(callback) {
  queueJob(callback);
}
function queueJob(job) {
  if (!queue.includes(job))
    queue.push(job);
  queueFlush();
}
function dequeueJob(job) {
  let index = queue.indexOf(job);
  if (index !== -1 && index > lastFlushedIndex)
    queue.splice(index, 1);
}
function queueFlush() {
  if (!flushing && !flushPending) {
    flushPending = true;
    queueMicrotask(flushJobs);
  }
}
function flushJobs() {
  flushPending = false;
  flushing = true;
  for (let i = 0; i < queue.length; i++) {
    queue[i]();
    lastFlushedIndex = i;
  }
  queue.length = 0;
  lastFlushedIndex = -1;
  flushing = false;
}
var reactive;
var effect;
var release;
var raw;
var shouldSchedule = true;
function disableEffectScheduling(callback) {
  shouldSchedule = false;
  callback();
  shouldSchedule = true;
}
function setReactivityEngine(engine) {
  reactive = engine.reactive;
  release = engine.release;
  effect = (callback) => engine.effect(callback, { scheduler: (task) => {
    if (shouldSchedule) {
      scheduler(task);
    } else {
      task();
    }
  } });
  raw = engine.raw;
}
function overrideEffect(override) {
  effect = override;
}
function elementBoundEffect(el) {
  let cleanup2 = () => {
  };
  let wrappedEffect = (callback) => {
    let effectReference = effect(callback);
    if (!el._x_effects) {
      el._x_effects = /* @__PURE__ */ new Set();
      el._x_runEffects = () => {
        el._x_effects.forEach((i) => i());
      };
    }
    el._x_effects.add(effectReference);
    cleanup2 = () => {
      if (effectReference === void 0)
        return;
      el._x_effects.delete(effectReference);
      release(effectReference);
    };
    return effectReference;
  };
  return [wrappedEffect, () => {
    cleanup2();
  }];
}
function watch(getter, callback) {
  let firstTime = true;
  let oldValue;
  let effectReference = effect(() => {
    let value = getter();
    JSON.stringify(value);
    if (!firstTime) {
      queueMicrotask(() => {
        callback(value, oldValue);
        oldValue = value;
      });
    } else {
      oldValue = value;
    }
    firstTime = false;
  });
  return () => release(effectReference);
}
var onAttributeAddeds = [];
var onElRemoveds = [];
var onElAddeds = [];
function onElAdded(callback) {
  onElAddeds.push(callback);
}
function onElRemoved(el, callback) {
  if (typeof callback === "function") {
    if (!el._x_cleanups)
      el._x_cleanups = [];
    el._x_cleanups.push(callback);
  } else {
    callback = el;
    onElRemoveds.push(callback);
  }
}
function onAttributesAdded(callback) {
  onAttributeAddeds.push(callback);
}
function onAttributeRemoved(el, name, callback) {
  if (!el._x_attributeCleanups)
    el._x_attributeCleanups = {};
  if (!el._x_attributeCleanups[name])
    el._x_attributeCleanups[name] = [];
  el._x_attributeCleanups[name].push(callback);
}
function cleanupAttributes(el, names) {
  if (!el._x_attributeCleanups)
    return;
  Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
    if (names === void 0 || names.includes(name)) {
      value.forEach((i) => i());
      delete el._x_attributeCleanups[name];
    }
  });
}
function cleanupElement(el) {
  var _a, _b;
  (_a = el._x_effects) == null ? void 0 : _a.forEach(dequeueJob);
  while ((_b = el._x_cleanups) == null ? void 0 : _b.length)
    el._x_cleanups.pop()();
}
var observer = new MutationObserver(onMutate);
var currentlyObserving = false;
function startObservingMutations() {
  observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
  currentlyObserving = true;
}
function stopObservingMutations() {
  flushObserver();
  observer.disconnect();
  currentlyObserving = false;
}
var queuedMutations = [];
function flushObserver() {
  let records = observer.takeRecords();
  queuedMutations.push(() => records.length > 0 && onMutate(records));
  let queueLengthWhenTriggered = queuedMutations.length;
  queueMicrotask(() => {
    if (queuedMutations.length === queueLengthWhenTriggered) {
      while (queuedMutations.length > 0)
        queuedMutations.shift()();
    }
  });
}
function mutateDom(callback) {
  if (!currentlyObserving)
    return callback();
  stopObservingMutations();
  let result = callback();
  startObservingMutations();
  return result;
}
var isCollecting = false;
var deferredMutations = [];
function deferMutations() {
  isCollecting = true;
}
function flushAndStopDeferringMutations() {
  isCollecting = false;
  onMutate(deferredMutations);
  deferredMutations = [];
}
function onMutate(mutations) {
  if (isCollecting) {
    deferredMutations = deferredMutations.concat(mutations);
    return;
  }
  let addedNodes = [];
  let removedNodes = /* @__PURE__ */ new Set();
  let addedAttributes = /* @__PURE__ */ new Map();
  let removedAttributes = /* @__PURE__ */ new Map();
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].target._x_ignoreMutationObserver)
      continue;
    if (mutations[i].type === "childList") {
      mutations[i].removedNodes.forEach((node) => {
        if (node.nodeType !== 1)
          return;
        if (!node._x_marker)
          return;
        removedNodes.add(node);
      });
      mutations[i].addedNodes.forEach((node) => {
        if (node.nodeType !== 1)
          return;
        if (removedNodes.has(node)) {
          removedNodes.delete(node);
          return;
        }
        if (node._x_marker)
          return;
        addedNodes.push(node);
      });
    }
    if (mutations[i].type === "attributes") {
      let el = mutations[i].target;
      let name = mutations[i].attributeName;
      let oldValue = mutations[i].oldValue;
      let add2 = () => {
        if (!addedAttributes.has(el))
          addedAttributes.set(el, []);
        addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
      };
      let remove = () => {
        if (!removedAttributes.has(el))
          removedAttributes.set(el, []);
        removedAttributes.get(el).push(name);
      };
      if (el.hasAttribute(name) && oldValue === null) {
        add2();
      } else if (el.hasAttribute(name)) {
        remove();
        add2();
      } else {
        remove();
      }
    }
  }
  removedAttributes.forEach((attrs, el) => {
    cleanupAttributes(el, attrs);
  });
  addedAttributes.forEach((attrs, el) => {
    onAttributeAddeds.forEach((i) => i(el, attrs));
  });
  for (let node of removedNodes) {
    if (addedNodes.some((i) => i.contains(node)))
      continue;
    onElRemoveds.forEach((i) => i(node));
  }
  for (let node of addedNodes) {
    if (!node.isConnected)
      continue;
    onElAddeds.forEach((i) => i(node));
  }
  addedNodes = null;
  removedNodes = null;
  addedAttributes = null;
  removedAttributes = null;
}
function scope(node) {
  return mergeProxies(closestDataStack(node));
}
function addScopeToNode(node, data2, referenceNode) {
  node._x_dataStack = [data2, ...closestDataStack(referenceNode || node)];
  return () => {
    node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
  };
}
function closestDataStack(node) {
  if (node._x_dataStack)
    return node._x_dataStack;
  if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
    return closestDataStack(node.host);
  }
  if (!node.parentNode) {
    return [];
  }
  return closestDataStack(node.parentNode);
}
function mergeProxies(objects) {
  return new Proxy({ objects }, mergeProxyTrap);
}
var mergeProxyTrap = {
  ownKeys({ objects }) {
    return Array.from(
      new Set(objects.flatMap((i) => Object.keys(i)))
    );
  },
  has({ objects }, name) {
    if (name == Symbol.unscopables)
      return false;
    return objects.some(
      (obj) => Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name)
    );
  },
  get({ objects }, name, thisProxy) {
    if (name == "toJSON")
      return collapseProxies;
    return Reflect.get(
      objects.find(
        (obj) => Reflect.has(obj, name)
      ) || {},
      name,
      thisProxy
    );
  },
  set({ objects }, name, value, thisProxy) {
    const target = objects.find(
      (obj) => Object.prototype.hasOwnProperty.call(obj, name)
    ) || objects[objects.length - 1];
    const descriptor = Object.getOwnPropertyDescriptor(target, name);
    if ((descriptor == null ? void 0 : descriptor.set) && (descriptor == null ? void 0 : descriptor.get))
      return descriptor.set.call(thisProxy, value) || true;
    return Reflect.set(target, name, value);
  }
};
function collapseProxies() {
  let keys = Reflect.ownKeys(this);
  return keys.reduce((acc, key) => {
    acc[key] = Reflect.get(this, key);
    return acc;
  }, {});
}
function initInterceptors(data2) {
  let isObject2 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
  let recurse = (obj, basePath = "") => {
    Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value, enumerable }]) => {
      if (enumerable === false || value === void 0)
        return;
      if (typeof value === "object" && value !== null && value.__v_skip)
        return;
      let path = basePath === "" ? key : `${basePath}.${key}`;
      if (typeof value === "object" && value !== null && value._x_interceptor) {
        obj[key] = value.initialize(data2, path, key);
      } else {
        if (isObject2(value) && value !== obj && !(value instanceof Element)) {
          recurse(value, path);
        }
      }
    });
  };
  return recurse(data2);
}
function interceptor(callback, mutateObj = () => {
}) {
  let obj = {
    initialValue: void 0,
    _x_interceptor: true,
    initialize(data2, path, key) {
      return callback(this.initialValue, () => get(data2, path), (value) => set(data2, path, value), path, key);
    }
  };
  mutateObj(obj);
  return (initialValue) => {
    if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
      let initialize = obj.initialize.bind(obj);
      obj.initialize = (data2, path, key) => {
        let innerValue = initialValue.initialize(data2, path, key);
        obj.initialValue = innerValue;
        return initialize(data2, path, key);
      };
    } else {
      obj.initialValue = initialValue;
    }
    return obj;
  };
}
function get(obj, path) {
  return path.split(".").reduce((carry, segment) => carry[segment], obj);
}
function set(obj, path, value) {
  if (typeof path === "string")
    path = path.split(".");
  if (path.length === 1)
    obj[path[0]] = value;
  else if (path.length === 0)
    throw error;
  else {
    if (obj[path[0]])
      return set(obj[path[0]], path.slice(1), value);
    else {
      obj[path[0]] = {};
      return set(obj[path[0]], path.slice(1), value);
    }
  }
}
var magics = {};
function magic(name, callback) {
  magics[name] = callback;
}
function injectMagics(obj, el) {
  let memoizedUtilities = getUtilities(el);
  Object.entries(magics).forEach(([name, callback]) => {
    Object.defineProperty(obj, `$${name}`, {
      get() {
        return callback(el, memoizedUtilities);
      },
      enumerable: false
    });
  });
  return obj;
}
function getUtilities(el) {
  let [utilities, cleanup2] = getElementBoundUtilities(el);
  let utils2 = { interceptor, ...utilities };
  onElRemoved(el, cleanup2);
  return utils2;
}
function tryCatch(el, expression, callback, ...args) {
  try {
    return callback(...args);
  } catch (e) {
    handleError(e, el, expression);
  }
}
function handleError(error2, el, expression = void 0) {
  error2 = Object.assign(
    error2 ?? { message: "No error message given." },
    { el, expression }
  );
  console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
  setTimeout(() => {
    throw error2;
  }, 0);
}
var shouldAutoEvaluateFunctions = true;
function dontAutoEvaluateFunctions(callback) {
  let cache = shouldAutoEvaluateFunctions;
  shouldAutoEvaluateFunctions = false;
  let result = callback();
  shouldAutoEvaluateFunctions = cache;
  return result;
}
function evaluate(el, expression, extras = {}) {
  let result;
  evaluateLater(el, expression)((value) => result = value, extras);
  return result;
}
function evaluateLater(...args) {
  return theEvaluatorFunction(...args);
}
var theEvaluatorFunction = normalEvaluator;
function setEvaluator(newEvaluator) {
  theEvaluatorFunction = newEvaluator;
}
function normalEvaluator(el, expression) {
  let overriddenMagics = {};
  injectMagics(overriddenMagics, el);
  let dataStack = [overriddenMagics, ...closestDataStack(el)];
  let evaluator = typeof expression === "function" ? generateEvaluatorFromFunction(dataStack, expression) : generateEvaluatorFromString(dataStack, expression, el);
  return tryCatch.bind(null, el, expression, evaluator);
}
function generateEvaluatorFromFunction(dataStack, func) {
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
    runIfTypeOfFunction(receiver, result);
  };
}
var evaluatorMemo = {};
function generateFunctionFromString(expression, el) {
  if (evaluatorMemo[expression]) {
    return evaluatorMemo[expression];
  }
  let AsyncFunction = Object.getPrototypeOf(async function() {
  }).constructor;
  let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
  const safeAsyncFunction = () => {
    try {
      let func2 = new AsyncFunction(
        ["__self", "scope"],
        `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
      );
      Object.defineProperty(func2, "name", {
        value: `[Alpine] ${expression}`
      });
      return func2;
    } catch (error2) {
      handleError(error2, el, expression);
      return Promise.resolve();
    }
  };
  let func = safeAsyncFunction();
  evaluatorMemo[expression] = func;
  return func;
}
function generateEvaluatorFromString(dataStack, expression, el) {
  let func = generateFunctionFromString(expression, el);
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    func.result = void 0;
    func.finished = false;
    let completeScope = mergeProxies([scope2, ...dataStack]);
    if (typeof func === "function") {
      let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
      if (func.finished) {
        runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
        func.result = void 0;
      } else {
        promise.then((result) => {
          runIfTypeOfFunction(receiver, result, completeScope, params, el);
        }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
      }
    }
  };
}
function runIfTypeOfFunction(receiver, value, scope2, params, el) {
  if (shouldAutoEvaluateFunctions && typeof value === "function") {
    let result = value.apply(scope2, params);
    if (result instanceof Promise) {
      result.then((i) => runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2) => handleError(error2, el, value));
    } else {
      receiver(result);
    }
  } else if (typeof value === "object" && value instanceof Promise) {
    value.then((i) => receiver(i));
  } else {
    receiver(value);
  }
}
var prefixAsString = "x-";
function prefix(subject = "") {
  return prefixAsString + subject;
}
function setPrefix(newPrefix) {
  prefixAsString = newPrefix;
}
var directiveHandlers = {};
function directive(name, callback) {
  directiveHandlers[name] = callback;
  return {
    before(directive2) {
      if (!directiveHandlers[directive2]) {
        console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
        return;
      }
      const pos = directiveOrder.indexOf(directive2);
      directiveOrder.splice(pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"), 0, name);
    }
  };
}
function directiveExists(name) {
  return Object.keys(directiveHandlers).includes(name);
}
function directives(el, attributes, originalAttributeOverride) {
  attributes = Array.from(attributes);
  if (el._x_virtualDirectives) {
    let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(vAttributes);
    vAttributes = vAttributes.map((attribute) => {
      if (staticAttributes.find((attr) => attr.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    attributes = attributes.concat(vAttributes);
  }
  let transformedAttributeMap = {};
  let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
  return directives2.map((directive2) => {
    return getDirectiveHandler(el, directive2);
  });
}
function attributesOnly(attributes) {
  return Array.from(attributes).map(toTransformedAttributes()).filter((attr) => !outNonAlpineAttributes(attr));
}
var isDeferringHandlers = false;
var directiveHandlerStacks = /* @__PURE__ */ new Map();
var currentHandlerStackKey = Symbol();
function deferHandlingDirectives(callback) {
  isDeferringHandlers = true;
  let key = Symbol();
  currentHandlerStackKey = key;
  directiveHandlerStacks.set(key, []);
  let flushHandlers = () => {
    while (directiveHandlerStacks.get(key).length)
      directiveHandlerStacks.get(key).shift()();
    directiveHandlerStacks.delete(key);
  };
  let stopDeferring = () => {
    isDeferringHandlers = false;
    flushHandlers();
  };
  callback(flushHandlers);
  stopDeferring();
}
function getElementBoundUtilities(el) {
  let cleanups = [];
  let cleanup2 = (callback) => cleanups.push(callback);
  let [effect3, cleanupEffect] = elementBoundEffect(el);
  cleanups.push(cleanupEffect);
  let utilities = {
    Alpine: alpine_default,
    effect: effect3,
    cleanup: cleanup2,
    evaluateLater: evaluateLater.bind(evaluateLater, el),
    evaluate: evaluate.bind(evaluate, el)
  };
  let doCleanup = () => cleanups.forEach((i) => i());
  return [utilities, doCleanup];
}
function getDirectiveHandler(el, directive2) {
  let noop = () => {
  };
  let handler4 = directiveHandlers[directive2.type] || noop;
  let [utilities, cleanup2] = getElementBoundUtilities(el);
  onAttributeRemoved(el, directive2.original, cleanup2);
  let fullHandler = () => {
    if (el._x_ignore || el._x_ignoreSelf)
      return;
    handler4.inline && handler4.inline(el, directive2, utilities);
    handler4 = handler4.bind(handler4, el, directive2, utilities);
    isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler4) : handler4();
  };
  fullHandler.runCleanups = cleanup2;
  return fullHandler;
}
var startingWith = (subject, replacement) => ({ name, value }) => {
  if (name.startsWith(subject))
    name = name.replace(subject, replacement);
  return { name, value };
};
var into = (i) => i;
function toTransformedAttributes(callback = () => {
}) {
  return ({ name, value }) => {
    let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform) => {
      return transform(carry);
    }, { name, value });
    if (newName !== name)
      callback(newName, name);
    return { name: newName, value: newValue };
  };
}
var attributeTransformers = [];
function mapAttributes(callback) {
  attributeTransformers.push(callback);
}
function outNonAlpineAttributes({ name }) {
  return alpineAttributeRegex().test(name);
}
var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
  return ({ name, value }) => {
    let typeMatch = name.match(alpineAttributeRegex());
    let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
    let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
    let original = originalAttributeOverride || transformedAttributeMap[name] || name;
    return {
      type: typeMatch ? typeMatch[1] : null,
      value: valueMatch ? valueMatch[1] : null,
      modifiers: modifiers.map((i) => i.replace(".", "")),
      expression: value,
      original
    };
  };
}
var DEFAULT = "DEFAULT";
var directiveOrder = [
  "ignore",
  "ref",
  "data",
  "id",
  "anchor",
  "bind",
  "init",
  "for",
  "model",
  "modelable",
  "transition",
  "show",
  "if",
  DEFAULT,
  "teleport"
];
function byPriority(a, b) {
  let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
  let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
  return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
}
function dispatch(el, name, detail = {}) {
  el.dispatchEvent(
    new CustomEvent(name, {
      detail,
      bubbles: true,
      // Allows events to pass the shadow DOM barrier.
      composed: true,
      cancelable: true
    })
  );
}
function walk(el, callback) {
  if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
    Array.from(el.children).forEach((el2) => walk(el2, callback));
    return;
  }
  let skip = false;
  callback(el, () => skip = true);
  if (skip)
    return;
  let node = el.firstElementChild;
  while (node) {
    walk(node, callback);
    node = node.nextElementSibling;
  }
}
function warn(message, ...args) {
  console.warn(`Alpine Warning: ${message}`, ...args);
}
var started = false;
function start() {
  if (started)
    warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
  started = true;
  if (!document.body)
    warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
  dispatch(document, "alpine:init");
  dispatch(document, "alpine:initializing");
  startObservingMutations();
  onElAdded((el) => initTree(el, walk));
  onElRemoved((el) => destroyTree(el));
  onAttributesAdded((el, attrs) => {
    directives(el, attrs).forEach((handle) => handle());
  });
  let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
  Array.from(document.querySelectorAll(allSelectors().join(","))).filter(outNestedComponents).forEach((el) => {
    initTree(el);
  });
  dispatch(document, "alpine:initialized");
  setTimeout(() => {
    warnAboutMissingPlugins();
  });
}
var rootSelectorCallbacks = [];
var initSelectorCallbacks = [];
function rootSelectors() {
  return rootSelectorCallbacks.map((fn) => fn());
}
function allSelectors() {
  return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
}
function addRootSelector(selectorCallback) {
  rootSelectorCallbacks.push(selectorCallback);
}
function addInitSelector(selectorCallback) {
  initSelectorCallbacks.push(selectorCallback);
}
function closestRoot(el, includeInitSelectors = false) {
  return findClosest(el, (element) => {
    const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
    if (selectors.some((selector) => element.matches(selector)))
      return true;
  });
}
function findClosest(el, callback) {
  if (!el)
    return;
  if (callback(el))
    return el;
  if (el._x_teleportBack)
    el = el._x_teleportBack;
  if (!el.parentElement)
    return;
  return findClosest(el.parentElement, callback);
}
function isRoot(el) {
  return rootSelectors().some((selector) => el.matches(selector));
}
var initInterceptors2 = [];
function interceptInit(callback) {
  initInterceptors2.push(callback);
}
var markerDispenser = 1;
function initTree(el, walker = walk, intercept = () => {
}) {
  if (findClosest(el, (i) => i._x_ignore))
    return;
  deferHandlingDirectives(() => {
    walker(el, (el2, skip) => {
      if (el2._x_marker)
        return;
      intercept(el2, skip);
      initInterceptors2.forEach((i) => i(el2, skip));
      directives(el2, el2.attributes).forEach((handle) => handle());
      if (!el2._x_ignore)
        el2._x_marker = markerDispenser++;
      el2._x_ignore && skip();
    });
  });
}
function destroyTree(root, walker = walk) {
  walker(root, (el) => {
    cleanupElement(el);
    cleanupAttributes(el);
    delete el._x_marker;
  });
}
function warnAboutMissingPlugins() {
  let pluginDirectives = [
    ["ui", "dialog", ["[x-dialog], [x-popover]"]],
    ["anchor", "anchor", ["[x-anchor]"]],
    ["sort", "sort", ["[x-sort]"]]
  ];
  pluginDirectives.forEach(([plugin2, directive2, selectors]) => {
    if (directiveExists(directive2))
      return;
    selectors.some((selector) => {
      if (document.querySelector(selector)) {
        warn(`found "${selector}", but missing ${plugin2} plugin`);
        return true;
      }
    });
  });
}
var tickStack = [];
var isHolding = false;
function nextTick(callback = () => {
}) {
  queueMicrotask(() => {
    isHolding || setTimeout(() => {
      releaseNextTicks();
    });
  });
  return new Promise((res) => {
    tickStack.push(() => {
      callback();
      res();
    });
  });
}
function releaseNextTicks() {
  isHolding = false;
  while (tickStack.length)
    tickStack.shift()();
}
function holdNextTicks() {
  isHolding = true;
}
function setClasses(el, value) {
  if (Array.isArray(value)) {
    return setClassesFromString(el, value.join(" "));
  } else if (typeof value === "object" && value !== null) {
    return setClassesFromObject(el, value);
  } else if (typeof value === "function") {
    return setClasses(el, value());
  }
  return setClassesFromString(el, value);
}
function setClassesFromString(el, classString) {
  let missingClasses = (classString2) => classString2.split(" ").filter((i) => !el.classList.contains(i)).filter(Boolean);
  let addClassesAndReturnUndo = (classes) => {
    el.classList.add(...classes);
    return () => {
      el.classList.remove(...classes);
    };
  };
  classString = classString === true ? classString = "" : classString || "";
  return addClassesAndReturnUndo(missingClasses(classString));
}
function setClassesFromObject(el, classObject) {
  let split = (classString) => classString.split(" ").filter(Boolean);
  let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
  let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
  let added = [];
  let removed = [];
  forRemove.forEach((i) => {
    if (el.classList.contains(i)) {
      el.classList.remove(i);
      removed.push(i);
    }
  });
  forAdd.forEach((i) => {
    if (!el.classList.contains(i)) {
      el.classList.add(i);
      added.push(i);
    }
  });
  return () => {
    removed.forEach((i) => el.classList.add(i));
    added.forEach((i) => el.classList.remove(i));
  };
}
function setStyles(el, value) {
  if (typeof value === "object" && value !== null) {
    return setStylesFromObject(el, value);
  }
  return setStylesFromString(el, value);
}
function setStylesFromObject(el, value) {
  let previousStyles = {};
  Object.entries(value).forEach(([key, value2]) => {
    previousStyles[key] = el.style[key];
    if (!key.startsWith("--")) {
      key = kebabCase(key);
    }
    el.style.setProperty(key, value2);
  });
  setTimeout(() => {
    if (el.style.length === 0) {
      el.removeAttribute("style");
    }
  });
  return () => {
    setStyles(el, previousStyles);
  };
}
function setStylesFromString(el, value) {
  let cache = el.getAttribute("style", value);
  el.setAttribute("style", value);
  return () => {
    el.setAttribute("style", cache || "");
  };
}
function kebabCase(subject) {
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function once(callback, fallback = () => {
}) {
  let called = false;
  return function() {
    if (!called) {
      called = true;
      callback.apply(this, arguments);
    } else {
      fallback.apply(this, arguments);
    }
  };
}
directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "function")
    expression = evaluate2(expression);
  if (expression === false)
    return;
  if (!expression || typeof expression === "boolean") {
    registerTransitionsFromHelper(el, modifiers, value);
  } else {
    registerTransitionsFromClassString(el, expression, value);
  }
});
function registerTransitionsFromClassString(el, classString, stage) {
  registerTransitionObject(el, setClasses, "");
  let directiveStorageMap = {
    "enter": (classes) => {
      el._x_transition.enter.during = classes;
    },
    "enter-start": (classes) => {
      el._x_transition.enter.start = classes;
    },
    "enter-end": (classes) => {
      el._x_transition.enter.end = classes;
    },
    "leave": (classes) => {
      el._x_transition.leave.during = classes;
    },
    "leave-start": (classes) => {
      el._x_transition.leave.start = classes;
    },
    "leave-end": (classes) => {
      el._x_transition.leave.end = classes;
    }
  };
  directiveStorageMap[stage](classString);
}
function registerTransitionsFromHelper(el, modifiers, stage) {
  registerTransitionObject(el, setStyles);
  let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
  let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
  let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
  if (modifiers.includes("in") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index) => index < modifiers.indexOf("out"));
  }
  if (modifiers.includes("out") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index) => index > modifiers.indexOf("out"));
  }
  let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
  let wantsOpacity = wantsAll || modifiers.includes("opacity");
  let wantsScale = wantsAll || modifiers.includes("scale");
  let opacityValue = wantsOpacity ? 0 : 1;
  let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
  let delay3 = modifierValue(modifiers, "delay", 0) / 1e3;
  let origin = modifierValue(modifiers, "origin", "center");
  let property = "opacity, transform";
  let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
  let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
  let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
  if (transitioningIn) {
    el._x_transition.enter.during = {
      transformOrigin: origin,
      transitionDelay: `${delay3}s`,
      transitionProperty: property,
      transitionDuration: `${durationIn}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.enter.start = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
    el._x_transition.enter.end = {
      opacity: 1,
      transform: `scale(1)`
    };
  }
  if (transitioningOut) {
    el._x_transition.leave.during = {
      transformOrigin: origin,
      transitionDelay: `${delay3}s`,
      transitionProperty: property,
      transitionDuration: `${durationOut}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.leave.start = {
      opacity: 1,
      transform: `scale(1)`
    };
    el._x_transition.leave.end = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
  }
}
function registerTransitionObject(el, setFunction, defaultValue = {}) {
  if (!el._x_transition)
    el._x_transition = {
      enter: { during: defaultValue, start: defaultValue, end: defaultValue },
      leave: { during: defaultValue, start: defaultValue, end: defaultValue },
      in(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.enter.during,
          start: this.enter.start,
          end: this.enter.end
        }, before, after);
      },
      out(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.leave.during,
          start: this.leave.start,
          end: this.leave.end
        }, before, after);
      }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
  const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
  let clickAwayCompatibleShow = () => nextTick2(show);
  if (value) {
    if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
      el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
    } else {
      el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
    }
    return;
  }
  el._x_hidePromise = el._x_transition ? new Promise((resolve, reject) => {
    el._x_transition.out(() => {
    }, () => resolve(hide));
    el._x_transitioning && el._x_transitioning.beforeCancel(() => reject({ isFromCancelledTransition: true }));
  }) : Promise.resolve(hide);
  queueMicrotask(() => {
    let closest = closestHide(el);
    if (closest) {
      if (!closest._x_hideChildren)
        closest._x_hideChildren = [];
      closest._x_hideChildren.push(el);
    } else {
      nextTick2(() => {
        let hideAfterChildren = (el2) => {
          let carry = Promise.all([
            el2._x_hidePromise,
            ...(el2._x_hideChildren || []).map(hideAfterChildren)
          ]).then(([i]) => i == null ? void 0 : i());
          delete el2._x_hidePromise;
          delete el2._x_hideChildren;
          return carry;
        };
        hideAfterChildren(el).catch((e) => {
          if (!e.isFromCancelledTransition)
            throw e;
        });
      });
    }
  });
};
function closestHide(el) {
  let parent = el.parentNode;
  if (!parent)
    return;
  return parent._x_hidePromise ? parent : closestHide(parent);
}
function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
}, after = () => {
}) {
  if (el._x_transitioning)
    el._x_transitioning.cancel();
  if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
    before();
    after();
    return;
  }
  let undoStart, undoDuring, undoEnd;
  performTransition(el, {
    start() {
      undoStart = setFunction(el, start2);
    },
    during() {
      undoDuring = setFunction(el, during);
    },
    before,
    end() {
      undoStart();
      undoEnd = setFunction(el, end);
    },
    after,
    cleanup() {
      undoDuring();
      undoEnd();
    }
  });
}
function performTransition(el, stages) {
  let interrupted, reachedBefore, reachedEnd;
  let finish = once(() => {
    mutateDom(() => {
      interrupted = true;
      if (!reachedBefore)
        stages.before();
      if (!reachedEnd) {
        stages.end();
        releaseNextTicks();
      }
      stages.after();
      if (el.isConnected)
        stages.cleanup();
      delete el._x_transitioning;
    });
  });
  el._x_transitioning = {
    beforeCancels: [],
    beforeCancel(callback) {
      this.beforeCancels.push(callback);
    },
    cancel: once(function() {
      while (this.beforeCancels.length) {
        this.beforeCancels.shift()();
      }
      finish();
    }),
    finish
  };
  mutateDom(() => {
    stages.start();
    stages.during();
  });
  holdNextTicks();
  requestAnimationFrame(() => {
    if (interrupted)
      return;
    let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
    let delay3 = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
    if (duration === 0)
      duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
    mutateDom(() => {
      stages.before();
    });
    reachedBefore = true;
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      mutateDom(() => {
        stages.end();
      });
      releaseNextTicks();
      setTimeout(el._x_transitioning.finish, duration + delay3);
      reachedEnd = true;
    });
  });
}
function modifierValue(modifiers, key, fallback) {
  if (modifiers.indexOf(key) === -1)
    return fallback;
  const rawValue = modifiers[modifiers.indexOf(key) + 1];
  if (!rawValue)
    return fallback;
  if (key === "scale") {
    if (isNaN(rawValue))
      return fallback;
  }
  if (key === "duration" || key === "delay") {
    let match = rawValue.match(/([0-9]+)ms/);
    if (match)
      return match[1];
  }
  if (key === "origin") {
    if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
      return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
    }
  }
  return rawValue;
}
var isCloning = false;
function skipDuringClone(callback, fallback = () => {
}) {
  return (...args) => isCloning ? fallback(...args) : callback(...args);
}
function onlyDuringClone(callback) {
  return (...args) => isCloning && callback(...args);
}
var interceptors = [];
function interceptClone(callback) {
  interceptors.push(callback);
}
function cloneNode(from, to) {
  interceptors.forEach((i) => i(from, to));
  isCloning = true;
  dontRegisterReactiveSideEffects(() => {
    initTree(to, (el, callback) => {
      callback(el, () => {
      });
    });
  });
  isCloning = false;
}
var isCloningLegacy = false;
function clone(oldEl, newEl) {
  if (!newEl._x_dataStack)
    newEl._x_dataStack = oldEl._x_dataStack;
  isCloning = true;
  isCloningLegacy = true;
  dontRegisterReactiveSideEffects(() => {
    cloneTree(newEl);
  });
  isCloning = false;
  isCloningLegacy = false;
}
function cloneTree(el) {
  let hasRunThroughFirstEl = false;
  let shallowWalker = (el2, callback) => {
    walk(el2, (el3, skip) => {
      if (hasRunThroughFirstEl && isRoot(el3))
        return skip();
      hasRunThroughFirstEl = true;
      callback(el3, skip);
    });
  };
  initTree(el, shallowWalker);
}
function dontRegisterReactiveSideEffects(callback) {
  let cache = effect;
  overrideEffect((callback2, el) => {
    let storedEffect = cache(callback2);
    release(storedEffect);
    return () => {
    };
  });
  callback();
  overrideEffect(cache);
}
function bind(el, name, value, modifiers = []) {
  if (!el._x_bindings)
    el._x_bindings = reactive({});
  el._x_bindings[name] = value;
  name = modifiers.includes("camel") ? camelCase(name) : name;
  switch (name) {
    case "value":
      bindInputValue(el, value);
      break;
    case "style":
      bindStyles(el, value);
      break;
    case "class":
      bindClasses(el, value);
      break;
    case "selected":
    case "checked":
      bindAttributeAndProperty(el, name, value);
      break;
    default:
      bindAttribute(el, name, value);
      break;
  }
}
function bindInputValue(el, value) {
  if (isRadio$1(el)) {
    if (el.attributes.value === void 0) {
      el.value = value;
    }
    if (window.fromModel) {
      if (typeof value === "boolean") {
        el.checked = safeParseBoolean(el.value) === value;
      } else {
        el.checked = checkedAttrLooseCompare(el.value, value);
      }
    }
  } else if (isCheckbox(el)) {
    if (Number.isInteger(value)) {
      el.value = value;
    } else if (!Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
      el.value = String(value);
    } else {
      if (Array.isArray(value)) {
        el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
      } else {
        el.checked = !!value;
      }
    }
  } else if (el.tagName === "SELECT") {
    updateSelect(el, value);
  } else {
    if (el.value === value)
      return;
    el.value = value === void 0 ? "" : value;
  }
}
function bindClasses(el, value) {
  if (el._x_undoAddedClasses)
    el._x_undoAddedClasses();
  el._x_undoAddedClasses = setClasses(el, value);
}
function bindStyles(el, value) {
  if (el._x_undoAddedStyles)
    el._x_undoAddedStyles();
  el._x_undoAddedStyles = setStyles(el, value);
}
function bindAttributeAndProperty(el, name, value) {
  bindAttribute(el, name, value);
  setPropertyIfChanged(el, name, value);
}
function bindAttribute(el, name, value) {
  if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
    el.removeAttribute(name);
  } else {
    if (isBooleanAttr(name))
      value = name;
    setIfChanged(el, name, value);
  }
}
function setIfChanged(el, attrName, value) {
  if (el.getAttribute(attrName) != value) {
    el.setAttribute(attrName, value);
  }
}
function setPropertyIfChanged(el, propName, value) {
  if (el[propName] !== value) {
    el[propName] = value;
  }
}
function updateSelect(el, value) {
  const arrayWrappedValue = [].concat(value).map((value2) => {
    return value2 + "";
  });
  Array.from(el.options).forEach((option) => {
    option.selected = arrayWrappedValue.includes(option.value);
  });
}
function camelCase(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function checkedAttrLooseCompare(valueA, valueB) {
  return valueA == valueB;
}
function safeParseBoolean(rawValue) {
  if ([1, "1", "true", "on", "yes", true].includes(rawValue)) {
    return true;
  }
  if ([0, "0", "false", "off", "no", false].includes(rawValue)) {
    return false;
  }
  return rawValue ? Boolean(rawValue) : null;
}
var booleanAttributes = /* @__PURE__ */ new Set([
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "defer",
  "disabled",
  "formnovalidate",
  "inert",
  "ismap",
  "itemscope",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "selected",
  "shadowrootclonable",
  "shadowrootdelegatesfocus",
  "shadowrootserializable"
]);
function isBooleanAttr(attrName) {
  return booleanAttributes.has(attrName);
}
function attributeShouldntBePreservedIfFalsy(name) {
  return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
}
function getBinding(el, name, fallback) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  return getAttributeBinding(el, name, fallback);
}
function extractProp(el, name, fallback, extract = true) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
    let binding = el._x_inlineBindings[name];
    binding.extract = extract;
    return dontAutoEvaluateFunctions(() => {
      return evaluate(el, binding.expression);
    });
  }
  return getAttributeBinding(el, name, fallback);
}
function getAttributeBinding(el, name, fallback) {
  let attr = el.getAttribute(name);
  if (attr === null)
    return typeof fallback === "function" ? fallback() : fallback;
  if (attr === "")
    return true;
  if (isBooleanAttr(name)) {
    return !![name, "true"].includes(attr);
  }
  return attr;
}
function isCheckbox(el) {
  return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function isRadio$1(el) {
  return el.type === "radio" || el.localName === "ui-radio";
}
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function throttle(func, limit) {
  let inThrottle;
  return function() {
    let context = this, args = arguments;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
function entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
  let firstRun = true;
  let outerHash;
  let reference = effect(() => {
    let outer = outerGet();
    let inner = innerGet();
    if (firstRun) {
      innerSet(cloneIfObject(outer));
      firstRun = false;
    } else {
      let outerHashLatest = JSON.stringify(outer);
      let innerHashLatest = JSON.stringify(inner);
      if (outerHashLatest !== outerHash) {
        innerSet(cloneIfObject(outer));
      } else if (outerHashLatest !== innerHashLatest) {
        outerSet(cloneIfObject(inner));
      } else ;
    }
    outerHash = JSON.stringify(outerGet());
    JSON.stringify(innerGet());
  });
  return () => {
    release(reference);
  };
}
function cloneIfObject(value) {
  return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
function plugin(callback) {
  let callbacks = Array.isArray(callback) ? callback : [callback];
  callbacks.forEach((i) => i(alpine_default));
}
var stores = {};
var isReactive = false;
function store(name, value) {
  if (!isReactive) {
    stores = reactive(stores);
    isReactive = true;
  }
  if (value === void 0) {
    return stores[name];
  }
  stores[name] = value;
  initInterceptors(stores[name]);
  if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
    stores[name].init();
  }
}
function getStores() {
  return stores;
}
var binds = {};
function bind2(name, bindings) {
  let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
  if (name instanceof Element) {
    return applyBindingsObject(name, getBindings());
  } else {
    binds[name] = getBindings;
  }
  return () => {
  };
}
function injectBindingProviders(obj) {
  Object.entries(binds).forEach(([name, callback]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback(...args);
        };
      }
    });
  });
  return obj;
}
function applyBindingsObject(el, obj, original) {
  let cleanupRunners = [];
  while (cleanupRunners.length)
    cleanupRunners.pop()();
  let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
  let staticAttributes = attributesOnly(attributes);
  attributes = attributes.map((attribute) => {
    if (staticAttributes.find((attr) => attr.name === attribute.name)) {
      return {
        name: `x-bind:${attribute.name}`,
        value: `"${attribute.value}"`
      };
    }
    return attribute;
  });
  directives(el, attributes, original).map((handle) => {
    cleanupRunners.push(handle.runCleanups);
    handle();
  });
  return () => {
    while (cleanupRunners.length)
      cleanupRunners.pop()();
  };
}
var datas = {};
function data(name, callback) {
  datas[name] = callback;
}
function injectDataProviders(obj, context) {
  Object.entries(datas).forEach(([name, callback]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback.bind(context)(...args);
        };
      },
      enumerable: false
    });
  });
  return obj;
}
var Alpine$1 = {
  get reactive() {
    return reactive;
  },
  get release() {
    return release;
  },
  get effect() {
    return effect;
  },
  get raw() {
    return raw;
  },
  version: "3.14.9",
  flushAndStopDeferringMutations,
  dontAutoEvaluateFunctions,
  disableEffectScheduling,
  startObservingMutations,
  stopObservingMutations,
  setReactivityEngine,
  onAttributeRemoved,
  onAttributesAdded,
  closestDataStack,
  skipDuringClone,
  onlyDuringClone,
  addRootSelector,
  addInitSelector,
  interceptClone,
  addScopeToNode,
  deferMutations,
  mapAttributes,
  evaluateLater,
  interceptInit,
  setEvaluator,
  mergeProxies,
  extractProp,
  findClosest,
  onElRemoved,
  closestRoot,
  destroyTree,
  interceptor,
  // INTERNAL: not public API and is subject to change without major release.
  transition,
  // INTERNAL
  setStyles,
  // INTERNAL
  mutateDom,
  directive,
  entangle,
  throttle,
  debounce,
  evaluate,
  initTree,
  nextTick,
  prefixed: prefix,
  prefix: setPrefix,
  plugin,
  magic,
  store,
  start,
  clone,
  // INTERNAL
  cloneNode,
  // INTERNAL
  bound: getBinding,
  $data: scope,
  watch,
  walk,
  data,
  bind: bind2
};
var alpine_default = Alpine$1;
function makeMap(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return (val) => !!map[val];
}
var EMPTY_OBJ = Object.freeze({});
var hasOwnProperty = Object.prototype.hasOwnProperty;
var hasOwn = (val, key) => hasOwnProperty.call(val, key);
var isArray = Array.isArray;
var isMap = (val) => toTypeString(val) === "[object Map]";
var isString = (val) => typeof val === "string";
var isSymbol = (val) => typeof val === "symbol";
var isObject = (val) => val !== null && typeof val === "object";
var objectToString = Object.prototype.toString;
var toTypeString = (value) => objectToString.call(value);
var toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
var targetMap = /* @__PURE__ */ new WeakMap();
var effectStack = [];
var activeEffect;
var ITERATE_KEY = Symbol("iterate");
var MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function isEffect(fn) {
  return fn && fn._isEffect === true;
}
function effect2(fn, options = EMPTY_OBJ) {
  if (isEffect(fn)) {
    fn = fn.raw;
  }
  const effect3 = createReactiveEffect(fn, options);
  if (!options.lazy) {
    effect3();
  }
  return effect3;
}
function stop(effect3) {
  if (effect3.active) {
    cleanup(effect3);
    if (effect3.options.onStop) {
      effect3.options.onStop();
    }
    effect3.active = false;
  }
}
var uid = 0;
function createReactiveEffect(fn, options) {
  const effect3 = function reactiveEffect() {
    if (!effect3.active) {
      return fn();
    }
    if (!effectStack.includes(effect3)) {
      cleanup(effect3);
      try {
        enableTracking();
        effectStack.push(effect3);
        activeEffect = effect3;
        return fn();
      } finally {
        effectStack.pop();
        resetTracking();
        activeEffect = effectStack[effectStack.length - 1];
      }
    }
  };
  effect3.id = uid++;
  effect3.allowRecurse = !!options.allowRecurse;
  effect3._isEffect = true;
  effect3.active = true;
  effect3.raw = fn;
  effect3.deps = [];
  effect3.options = options;
  return effect3;
}
function cleanup(effect3) {
  const { deps } = effect3;
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].delete(effect3);
    }
    deps.length = 0;
  }
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function enableTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = true;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (!shouldTrack || activeEffect === void 0) {
    return;
  }
  let depsMap = targetMap.get(target);
  if (!depsMap) {
    targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
  }
  let dep = depsMap.get(key);
  if (!dep) {
    depsMap.set(key, dep = /* @__PURE__ */ new Set());
  }
  if (!dep.has(activeEffect)) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
    if (activeEffect.options.onTrack) {
      activeEffect.options.onTrack({
        effect: activeEffect,
        target,
        type,
        key
      });
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  const effects = /* @__PURE__ */ new Set();
  const add2 = (effectsToAdd) => {
    if (effectsToAdd) {
      effectsToAdd.forEach((effect3) => {
        if (effect3 !== activeEffect || effect3.allowRecurse) {
          effects.add(effect3);
        }
      });
    }
  };
  if (type === "clear") {
    depsMap.forEach(add2);
  } else if (key === "length" && isArray(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        add2(dep);
      }
    });
  } else {
    if (key !== void 0) {
      add2(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          add2(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap(target)) {
          add2(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  const run = (effect3) => {
    if (effect3.options.onTrigger) {
      effect3.options.onTrigger({
        effect: effect3,
        target,
        key,
        type,
        newValue,
        oldValue,
        oldTarget
      });
    }
    if (effect3.options.scheduler) {
      effect3.options.scheduler(effect3);
    } else {
      effect3();
    }
  };
  effects.forEach(run);
}
var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
var get2 = /* @__PURE__ */ createGetter();
var readonlyGet = /* @__PURE__ */ createGetter(true);
var arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const instrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    instrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i = 0, l = this.length; i < l; i++) {
        track(arr, "get", i + "");
      }
      const res = arr[key](...args);
      if (res === -1 || res === false) {
        return arr[key](...args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    instrumentations[key] = function(...args) {
      pauseTracking();
      const res = toRaw(this)[key].apply(this, args);
      resetTracking();
      return res;
    };
  });
  return instrumentations;
}
function createGetter(isReadonly = false, shallow = false) {
  return function get3(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
      return shouldUnwrap ? res.value : res;
    }
    if (isObject(res)) {
      return isReadonly ? readonly(res) : reactive2(res);
    }
    return res;
  };
}
var set2 = /* @__PURE__ */ createSetter();
function createSetter(shallow = false) {
  return function set3(target, key, value, receiver) {
    let oldValue = target[key];
    if (!shallow) {
      value = toRaw(value);
      oldValue = toRaw(oldValue);
      if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value, oldValue);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn(target, key);
  const oldValue = target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function has(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys$1(target) {
  track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
var mutableHandlers = {
  get: get2,
  set: set2,
  deleteProperty,
  has,
  ownKeys: ownKeys$1
};
var readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    {
      console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  },
  deleteProperty(target, key) {
    {
      console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  }
};
var toReactive = (value) => isObject(value) ? reactive2(value) : value;
var toReadonly = (value) => isObject(value) ? readonly(value) : value;
var toShallow = (value) => value;
var getProto = (v) => Reflect.getPrototypeOf(v);
function get$1(target, key, isReadonly = false, isShallow = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "get", key);
  }
  !isReadonly && track(rawTarget, "get", rawKey);
  const { has: has2 } = getProto(rawTarget);
  const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1(key, isReadonly = false) {
  const target = this[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "has", key);
  }
  !isReadonly && track(rawTarget, "has", rawKey);
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger(target, "add", key, value);
  } else if (hasChanged(value, oldValue)) {
    trigger(target, "set", key, value, oldValue);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3 ? get3.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const oldTarget = isMap(target) ? new Map(target) : new Set(target);
  const result = target.clear();
  if (hadItems) {
    trigger(target, "clear", void 0, void 0, oldTarget);
  }
  return result;
}
function createForEach(isReadonly, isShallow) {
  return function forEach(callback, thisArg) {
    const observed = this;
    const target = observed[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly, isShallow) {
  return function(...args) {
    const target = this[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    {
      const key = args[0] ? `on key "${args[0]}" ` : ``;
      console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
    }
    return type === "delete" ? false : this;
  };
}
function createInstrumentations() {
  const mutableInstrumentations2 = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  const shallowInstrumentations2 = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  const readonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod(
      "add"
      /* ADD */
    ),
    set: createReadonlyMethod(
      "set"
      /* SET */
    ),
    delete: createReadonlyMethod(
      "delete"
      /* DELETE */
    ),
    clear: createReadonlyMethod(
      "clear"
      /* CLEAR */
    ),
    forEach: createForEach(true, false)
  };
  const shallowReadonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod(
      "add"
      /* ADD */
    ),
    set: createReadonlyMethod(
      "set"
      /* SET */
    ),
    delete: createReadonlyMethod(
      "delete"
      /* DELETE */
    ),
    clear: createReadonlyMethod(
      "clear"
      /* CLEAR */
    ),
    forEach: createForEach(true, true)
  };
  const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations2[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
    shallowInstrumentations2[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
  });
  return [
    mutableInstrumentations2,
    readonlyInstrumentations2,
    shallowInstrumentations2,
    shallowReadonlyInstrumentations2
  ];
}
var [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly, shallow) {
  const instrumentations = isReadonly ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
var mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false)
};
var readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true)
};
function checkIdentityKeys(target, has2, key) {
  const rawKey = toRaw(key);
  if (rawKey !== key && has2.call(target, rawKey)) {
    const type = toRawType(target);
    console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
  }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value[
    "__v_skip"
    /* SKIP */
  ] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive2(target) {
  if (target && target[
    "__v_isReadonly"
    /* IS_READONLY */
  ]) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject(target)) {
    {
      console.warn(`value cannot be made reactive: ${String(target)}`);
    }
    return target;
  }
  if (target[
    "__v_raw"
    /* RAW */
  ] && !(isReadonly && target[
    "__v_isReactive"
    /* IS_REACTIVE */
  ])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function toRaw(observed) {
  return observed && toRaw(observed[
    "__v_raw"
    /* RAW */
  ]) || observed;
}
function isRef(r) {
  return Boolean(r && r.__v_isRef === true);
}
magic("nextTick", () => nextTick);
magic("dispatch", (el) => dispatch.bind(dispatch, el));
magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => (key, callback) => {
  let evaluate2 = evaluateLater2(key);
  let getter = () => {
    let value;
    evaluate2((i) => value = i);
    return value;
  };
  let unwatch = watch(getter, callback);
  cleanup2(unwatch);
});
magic("store", getStores);
magic("data", (el) => scope(el));
magic("root", (el) => closestRoot(el));
magic("refs", (el) => {
  if (el._x_refs_proxy)
    return el._x_refs_proxy;
  el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
  return el._x_refs_proxy;
});
function getArrayOfRefObject(el) {
  let refObjects = [];
  findClosest(el, (i) => {
    if (i._x_refs)
      refObjects.push(i._x_refs);
  });
  return refObjects;
}
var globalIdMemo = {};
function findAndIncrementId(name) {
  if (!globalIdMemo[name])
    globalIdMemo[name] = 0;
  return ++globalIdMemo[name];
}
function closestIdRoot(el, name) {
  return findClosest(el, (element) => {
    if (element._x_ids && element._x_ids[name])
      return true;
  });
}
function setIdRoot(el, name) {
  if (!el._x_ids)
    el._x_ids = {};
  if (!el._x_ids[name])
    el._x_ids[name] = findAndIncrementId(name);
}
magic("id", (el, { cleanup: cleanup2 }) => (name, key = null) => {
  let cacheKey = `${name}${key ? `-${key}` : ""}`;
  return cacheIdByNameOnElement(el, cacheKey, cleanup2, () => {
    let root = closestIdRoot(el, name);
    let id = root ? root._x_ids[name] : findAndIncrementId(name);
    return key ? `${name}-${id}-${key}` : `${name}-${id}`;
  });
});
interceptClone((from, to) => {
  if (from._x_id) {
    to._x_id = from._x_id;
  }
});
function cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
  if (!el._x_id)
    el._x_id = {};
  if (el._x_id[cacheKey])
    return el._x_id[cacheKey];
  let output = callback();
  el._x_id[cacheKey] = output;
  cleanup2(() => {
    delete el._x_id[cacheKey];
  });
  return output;
}
magic("el", (el) => el);
warnMissingPluginMagic("Focus", "focus", "focus");
warnMissingPluginMagic("Persist", "persist", "persist");
function warnMissingPluginMagic(name, magicName, slug) {
  magic(magicName, (el) => warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
directive("modelable", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
  let func = evaluateLater2(expression);
  let innerGet = () => {
    let result;
    func((i) => result = i);
    return result;
  };
  let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
  let innerSet = (val) => evaluateInnerSet(() => {
  }, { scope: { "__placeholder": val } });
  let initialValue = innerGet();
  innerSet(initialValue);
  queueMicrotask(() => {
    if (!el._x_model)
      return;
    el._x_removeModelListeners["default"]();
    let outerGet = el._x_model.get;
    let outerSet = el._x_model.set;
    let releaseEntanglement = entangle(
      {
        get() {
          return outerGet();
        },
        set(value) {
          outerSet(value);
        }
      },
      {
        get() {
          return innerGet();
        },
        set(value) {
          innerSet(value);
        }
      }
    );
    cleanup2(releaseEntanglement);
  });
});
directive("teleport", (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-teleport can only be used on a <template> tag", el);
  let target = getTarget(expression);
  let clone2 = el.content.cloneNode(true).firstElementChild;
  el._x_teleport = clone2;
  clone2._x_teleportBack = el;
  el.setAttribute("data-teleport-template", true);
  clone2.setAttribute("data-teleport-target", true);
  if (el._x_forwardEvents) {
    el._x_forwardEvents.forEach((eventName) => {
      clone2.addEventListener(eventName, (e) => {
        e.stopPropagation();
        el.dispatchEvent(new e.constructor(e.type, e));
      });
    });
  }
  addScopeToNode(clone2, {}, el);
  let placeInDom = (clone3, target2, modifiers2) => {
    if (modifiers2.includes("prepend")) {
      target2.parentNode.insertBefore(clone3, target2);
    } else if (modifiers2.includes("append")) {
      target2.parentNode.insertBefore(clone3, target2.nextSibling);
    } else {
      target2.appendChild(clone3);
    }
  };
  mutateDom(() => {
    placeInDom(clone2, target, modifiers);
    skipDuringClone(() => {
      initTree(clone2);
    })();
  });
  el._x_teleportPutBack = () => {
    let target2 = getTarget(expression);
    mutateDom(() => {
      placeInDom(el._x_teleport, target2, modifiers);
    });
  };
  cleanup2(
    () => mutateDom(() => {
      clone2.remove();
      destroyTree(clone2);
    })
  );
});
var teleportContainerDuringClone = document.createElement("div");
function getTarget(expression) {
  let target = skipDuringClone(() => {
    return document.querySelector(expression);
  }, () => {
    return teleportContainerDuringClone;
  })();
  if (!target)
    warn(`Cannot find x-teleport element for selector: "${expression}"`);
  return target;
}
var handler = () => {
};
handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
  modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
  cleanup2(() => {
    modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
  });
};
directive("ignore", handler);
directive("effect", skipDuringClone((el, { expression }, { effect: effect3 }) => {
  effect3(evaluateLater(el, expression));
}));
function on(el, event2, modifiers, callback) {
  let listenerTarget = el;
  let handler4 = (e) => callback(e);
  let options = {};
  let wrapHandler = (callback2, wrapper) => (e) => wrapper(callback2, e);
  if (modifiers.includes("dot"))
    event2 = dotSyntax(event2);
  if (modifiers.includes("camel"))
    event2 = camelCase2(event2);
  if (modifiers.includes("passive"))
    options.passive = true;
  if (modifiers.includes("capture"))
    options.capture = true;
  if (modifiers.includes("window"))
    listenerTarget = window;
  if (modifiers.includes("document"))
    listenerTarget = document;
  if (modifiers.includes("debounce")) {
    let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler4 = debounce(handler4, wait);
  }
  if (modifiers.includes("throttle")) {
    let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler4 = throttle(handler4, wait);
  }
  if (modifiers.includes("prevent"))
    handler4 = wrapHandler(handler4, (next, e) => {
      e.preventDefault();
      next(e);
    });
  if (modifiers.includes("stop"))
    handler4 = wrapHandler(handler4, (next, e) => {
      e.stopPropagation();
      next(e);
    });
  if (modifiers.includes("once")) {
    handler4 = wrapHandler(handler4, (next, e) => {
      next(e);
      listenerTarget.removeEventListener(event2, handler4, options);
    });
  }
  if (modifiers.includes("away") || modifiers.includes("outside")) {
    listenerTarget = document;
    handler4 = wrapHandler(handler4, (next, e) => {
      if (el.contains(e.target))
        return;
      if (e.target.isConnected === false)
        return;
      if (el.offsetWidth < 1 && el.offsetHeight < 1)
        return;
      if (el._x_isShown === false)
        return;
      next(e);
    });
  }
  if (modifiers.includes("self"))
    handler4 = wrapHandler(handler4, (next, e) => {
      e.target === el && next(e);
    });
  if (isKeyEvent(event2) || isClickEvent(event2)) {
    handler4 = wrapHandler(handler4, (next, e) => {
      if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) {
        return;
      }
      next(e);
    });
  }
  listenerTarget.addEventListener(event2, handler4, options);
  return () => {
    listenerTarget.removeEventListener(event2, handler4, options);
  };
}
function dotSyntax(subject) {
  return subject.replace(/-/g, ".");
}
function camelCase2(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function isNumeric(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function kebabCase2(subject) {
  if ([" ", "_"].includes(
    subject
  ))
    return subject;
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function isKeyEvent(event2) {
  return ["keydown", "keyup"].includes(event2);
}
function isClickEvent(event2) {
  return ["contextmenu", "click", "mouse"].some((i) => event2.includes(i));
}
function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
  let keyModifiers = modifiers.filter((i) => {
    return !["window", "document", "prevent", "stop", "once", "capture", "self", "away", "outside", "passive"].includes(i);
  });
  if (keyModifiers.includes("debounce")) {
    let debounceIndex = keyModifiers.indexOf("debounce");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.includes("throttle")) {
    let debounceIndex = keyModifiers.indexOf("throttle");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.length === 0)
    return false;
  if (keyModifiers.length === 1 && keyToModifiers(e.key).includes(keyModifiers[0]))
    return false;
  const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
  const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
  keyModifiers = keyModifiers.filter((i) => !selectedSystemKeyModifiers.includes(i));
  if (selectedSystemKeyModifiers.length > 0) {
    const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
      if (modifier === "cmd" || modifier === "super")
        modifier = "meta";
      return e[`${modifier}Key`];
    });
    if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
      if (isClickEvent(e.type))
        return false;
      if (keyToModifiers(e.key).includes(keyModifiers[0]))
        return false;
    }
  }
  return true;
}
function keyToModifiers(key) {
  if (!key)
    return [];
  key = kebabCase2(key);
  let modifierToKeyMap = {
    "ctrl": "control",
    "slash": "/",
    "space": " ",
    "spacebar": " ",
    "cmd": "meta",
    "esc": "escape",
    "up": "arrow-up",
    "down": "arrow-down",
    "left": "arrow-left",
    "right": "arrow-right",
    "period": ".",
    "comma": ",",
    "equal": "=",
    "minus": "-",
    "underscore": "_"
  };
  modifierToKeyMap[key] = key;
  return Object.keys(modifierToKeyMap).map((modifier) => {
    if (modifierToKeyMap[modifier] === key)
      return modifier;
  }).filter((modifier) => modifier);
}
directive("model", (el, { modifiers, expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let scopeTarget = el;
  if (modifiers.includes("parent")) {
    scopeTarget = el.parentNode;
  }
  let evaluateGet = evaluateLater(scopeTarget, expression);
  let evaluateSet;
  if (typeof expression === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression} = __placeholder`);
  } else if (typeof expression === "function" && typeof expression() === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression()} = __placeholder`);
  } else {
    evaluateSet = () => {
    };
  }
  let getValue = () => {
    let result;
    evaluateGet((value) => result = value);
    return isGetterSetter(result) ? result.get() : result;
  };
  let setValue = (value) => {
    let result;
    evaluateGet((value2) => result = value2);
    if (isGetterSetter(result)) {
      result.set(value);
    } else {
      evaluateSet(() => {
      }, {
        scope: { "__placeholder": value }
      });
    }
  };
  if (typeof expression === "string" && el.type === "radio") {
    mutateDom(() => {
      if (!el.hasAttribute("name"))
        el.setAttribute("name", expression);
    });
  }
  var event2 = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
  let removeListener = isCloning ? () => {
  } : on(el, event2, modifiers, (e) => {
    setValue(getInputValue(el, modifiers, e, getValue()));
  });
  if (modifiers.includes("fill")) {
    if ([void 0, null, ""].includes(getValue()) || isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) {
      setValue(
        getInputValue(el, modifiers, { target: el }, getValue())
      );
    }
  }
  if (!el._x_removeModelListeners)
    el._x_removeModelListeners = {};
  el._x_removeModelListeners["default"] = removeListener;
  cleanup2(() => el._x_removeModelListeners["default"]());
  if (el.form) {
    let removeResetListener = on(el.form, "reset", [], (e) => {
      nextTick(() => el._x_model && el._x_model.set(getInputValue(el, modifiers, { target: el }, getValue())));
    });
    cleanup2(() => removeResetListener());
  }
  el._x_model = {
    get() {
      return getValue();
    },
    set(value) {
      setValue(value);
    }
  };
  el._x_forceModelUpdate = (value) => {
    if (value === void 0 && typeof expression === "string" && expression.match(/\./))
      value = "";
    window.fromModel = true;
    mutateDom(() => bind(el, "value", value));
    delete window.fromModel;
  };
  effect3(() => {
    let value = getValue();
    if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
      return;
    el._x_forceModelUpdate(value);
  });
});
function getInputValue(el, modifiers, event2, currentValue) {
  return mutateDom(() => {
    if (event2 instanceof CustomEvent && event2.detail !== void 0)
      return event2.detail !== null && event2.detail !== void 0 ? event2.detail : event2.target.value;
    else if (isCheckbox(el)) {
      if (Array.isArray(currentValue)) {
        let newValue = null;
        if (modifiers.includes("number")) {
          newValue = safeParseNumber(event2.target.value);
        } else if (modifiers.includes("boolean")) {
          newValue = safeParseBoolean(event2.target.value);
        } else {
          newValue = event2.target.value;
        }
        return event2.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
      } else {
        return event2.target.checked;
      }
    } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
      if (modifiers.includes("number")) {
        return Array.from(event2.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseNumber(rawValue);
        });
      } else if (modifiers.includes("boolean")) {
        return Array.from(event2.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseBoolean(rawValue);
        });
      }
      return Array.from(event2.target.selectedOptions).map((option) => {
        return option.value || option.text;
      });
    } else {
      let newValue;
      if (isRadio$1(el)) {
        if (event2.target.checked) {
          newValue = event2.target.value;
        } else {
          newValue = currentValue;
        }
      } else {
        newValue = event2.target.value;
      }
      if (modifiers.includes("number")) {
        return safeParseNumber(newValue);
      } else if (modifiers.includes("boolean")) {
        return safeParseBoolean(newValue);
      } else if (modifiers.includes("trim")) {
        return newValue.trim();
      } else {
        return newValue;
      }
    }
  });
}
function safeParseNumber(rawValue) {
  let number = rawValue ? parseFloat(rawValue) : null;
  return isNumeric2(number) ? number : rawValue;
}
function checkedAttrLooseCompare2(valueA, valueB) {
  return valueA == valueB;
}
function isNumeric2(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function isGetterSetter(value) {
  return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
addInitSelector(() => `[${prefix("init")}]`);
directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "string") {
    return !!expression.trim() && evaluate2(expression, {}, false);
  }
  return evaluate2(expression, {}, false);
}));
directive("text", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.textContent = value;
      });
    });
  });
});
directive("html", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.innerHTML = value;
        el._x_ignoreSelf = true;
        initTree(el);
        delete el._x_ignoreSelf;
      });
    });
  });
});
mapAttributes(startingWith(":", into(prefix("bind:"))));
var handler2 = (el, { value, modifiers, expression, original }, { effect: effect3, cleanup: cleanup2 }) => {
  if (!value) {
    let bindingProviders = {};
    injectBindingProviders(bindingProviders);
    let getBindings = evaluateLater(el, expression);
    getBindings((bindings) => {
      applyBindingsObject(el, bindings, original);
    }, { scope: bindingProviders });
    return;
  }
  if (value === "key")
    return storeKeyForXFor(el, expression);
  if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) {
    return;
  }
  let evaluate2 = evaluateLater(el, expression);
  effect3(() => evaluate2((result) => {
    if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
      result = "";
    }
    mutateDom(() => bind(el, value, result, modifiers));
  }));
  cleanup2(() => {
    el._x_undoAddedClasses && el._x_undoAddedClasses();
    el._x_undoAddedStyles && el._x_undoAddedStyles();
  });
};
handler2.inline = (el, { value, modifiers, expression }) => {
  if (!value)
    return;
  if (!el._x_inlineBindings)
    el._x_inlineBindings = {};
  el._x_inlineBindings[value] = { expression, extract: false };
};
directive("bind", handler2);
function storeKeyForXFor(el, expression) {
  el._x_keyExpression = expression;
}
addRootSelector(() => `[${prefix("data")}]`);
directive("data", (el, { expression }, { cleanup: cleanup2 }) => {
  if (shouldSkipRegisteringDataDuringClone(el))
    return;
  expression = expression === "" ? "{}" : expression;
  let magicContext = {};
  injectMagics(magicContext, el);
  let dataProviderContext = {};
  injectDataProviders(dataProviderContext, magicContext);
  let data2 = evaluate(el, expression, { scope: dataProviderContext });
  if (data2 === void 0 || data2 === true)
    data2 = {};
  injectMagics(data2, el);
  let reactiveData = reactive(data2);
  initInterceptors(reactiveData);
  let undo = addScopeToNode(el, reactiveData);
  reactiveData["init"] && evaluate(el, reactiveData["init"]);
  cleanup2(() => {
    reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
    undo();
  });
});
interceptClone((from, to) => {
  if (from._x_dataStack) {
    to._x_dataStack = from._x_dataStack;
    to.setAttribute("data-has-alpine-state", true);
  }
});
function shouldSkipRegisteringDataDuringClone(el) {
  if (!isCloning)
    return false;
  if (isCloningLegacy)
    return true;
  return el.hasAttribute("data-has-alpine-state");
}
directive("show", (el, { modifiers, expression }, { effect: effect3 }) => {
  let evaluate2 = evaluateLater(el, expression);
  if (!el._x_doHide)
    el._x_doHide = () => {
      mutateDom(() => {
        el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
      });
    };
  if (!el._x_doShow)
    el._x_doShow = () => {
      mutateDom(() => {
        if (el.style.length === 1 && el.style.display === "none") {
          el.removeAttribute("style");
        } else {
          el.style.removeProperty("display");
        }
      });
    };
  let hide = () => {
    el._x_doHide();
    el._x_isShown = false;
  };
  let show = () => {
    el._x_doShow();
    el._x_isShown = true;
  };
  let clickAwayCompatibleShow = () => setTimeout(show);
  let toggle = once(
    (value) => value ? show() : hide(),
    (value) => {
      if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
        el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
      } else {
        value ? clickAwayCompatibleShow() : hide();
      }
    }
  );
  let oldValue;
  let firstTime = true;
  effect3(() => evaluate2((value) => {
    if (!firstTime && value === oldValue)
      return;
    if (modifiers.includes("immediate"))
      value ? clickAwayCompatibleShow() : hide();
    toggle(value);
    oldValue = value;
    firstTime = false;
  }));
});
directive("for", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let iteratorNames = parseForExpression(expression);
  let evaluateItems = evaluateLater(el, iteratorNames.items);
  let evaluateKey = evaluateLater(
    el,
    // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index"
  );
  el._x_prevKeys = [];
  el._x_lookup = {};
  effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
  cleanup2(() => {
    Object.values(el._x_lookup).forEach((el2) => mutateDom(
      () => {
        destroyTree(el2);
        el2.remove();
      }
    ));
    delete el._x_prevKeys;
    delete el._x_lookup;
  });
});
function loop(el, iteratorNames, evaluateItems, evaluateKey) {
  let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
  let templateEl = el;
  evaluateItems((items) => {
    if (isNumeric3(items) && items >= 0) {
      items = Array.from(Array(items).keys(), (i) => i + 1);
    }
    if (items === void 0)
      items = [];
    let lookup = el._x_lookup;
    let prevKeys = el._x_prevKeys;
    let scopes = [];
    let keys = [];
    if (isObject2(items)) {
      items = Object.entries(items).map(([key, value]) => {
        let scope2 = getIterationScopeVariables(iteratorNames, value, key, items);
        evaluateKey((value2) => {
          if (keys.includes(value2))
            warn("Duplicate key on x-for", el);
          keys.push(value2);
        }, { scope: { index: key, ...scope2 } });
        scopes.push(scope2);
      });
    } else {
      for (let i = 0; i < items.length; i++) {
        let scope2 = getIterationScopeVariables(iteratorNames, items[i], i, items);
        evaluateKey((value) => {
          if (keys.includes(value))
            warn("Duplicate key on x-for", el);
          keys.push(value);
        }, { scope: { index: i, ...scope2 } });
        scopes.push(scope2);
      }
    }
    let adds = [];
    let moves = [];
    let removes = [];
    let sames = [];
    for (let i = 0; i < prevKeys.length; i++) {
      let key = prevKeys[i];
      if (keys.indexOf(key) === -1)
        removes.push(key);
    }
    prevKeys = prevKeys.filter((key) => !removes.includes(key));
    let lastKey = "template";
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      let prevIndex = prevKeys.indexOf(key);
      if (prevIndex === -1) {
        prevKeys.splice(i, 0, key);
        adds.push([lastKey, i]);
      } else if (prevIndex !== i) {
        let keyInSpot = prevKeys.splice(i, 1)[0];
        let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
        prevKeys.splice(i, 0, keyForSpot);
        prevKeys.splice(prevIndex, 0, keyInSpot);
        moves.push([keyInSpot, keyForSpot]);
      } else {
        sames.push(key);
      }
      lastKey = key;
    }
    for (let i = 0; i < removes.length; i++) {
      let key = removes[i];
      if (!(key in lookup))
        continue;
      mutateDom(() => {
        destroyTree(lookup[key]);
        lookup[key].remove();
      });
      delete lookup[key];
    }
    for (let i = 0; i < moves.length; i++) {
      let [keyInSpot, keyForSpot] = moves[i];
      let elInSpot = lookup[keyInSpot];
      let elForSpot = lookup[keyForSpot];
      let marker = document.createElement("div");
      mutateDom(() => {
        if (!elForSpot)
          warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
        elForSpot.after(marker);
        elInSpot.after(elForSpot);
        elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
        marker.before(elInSpot);
        elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
        marker.remove();
      });
      elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
    }
    for (let i = 0; i < adds.length; i++) {
      let [lastKey2, index] = adds[i];
      let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
      if (lastEl._x_currentIfEl)
        lastEl = lastEl._x_currentIfEl;
      let scope2 = scopes[index];
      let key = keys[index];
      let clone2 = document.importNode(templateEl.content, true).firstElementChild;
      let reactiveScope = reactive(scope2);
      addScopeToNode(clone2, reactiveScope, templateEl);
      clone2._x_refreshXForScope = (newScope) => {
        Object.entries(newScope).forEach(([key2, value]) => {
          reactiveScope[key2] = value;
        });
      };
      mutateDom(() => {
        lastEl.after(clone2);
        skipDuringClone(() => initTree(clone2))();
      });
      if (typeof key === "object") {
        warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
      }
      lookup[key] = clone2;
    }
    for (let i = 0; i < sames.length; i++) {
      lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
    }
    templateEl._x_prevKeys = keys;
  });
}
function parseForExpression(expression) {
  let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  let stripParensRE = /^\s*\(|\)\s*$/g;
  let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  let inMatch = expression.match(forAliasRE);
  if (!inMatch)
    return;
  let res = {};
  res.items = inMatch[2].trim();
  let item = inMatch[1].replace(stripParensRE, "").trim();
  let iteratorMatch = item.match(forIteratorRE);
  if (iteratorMatch) {
    res.item = item.replace(forIteratorRE, "").trim();
    res.index = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.collection = iteratorMatch[2].trim();
    }
  } else {
    res.item = item;
  }
  return res;
}
function getIterationScopeVariables(iteratorNames, item, index, items) {
  let scopeVariables = {};
  if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
    let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i) => i.trim());
    names.forEach((name, i) => {
      scopeVariables[name] = item[i];
    });
  } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
    let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i) => i.trim());
    names.forEach((name) => {
      scopeVariables[name] = item[name];
    });
  } else {
    scopeVariables[iteratorNames.item] = item;
  }
  if (iteratorNames.index)
    scopeVariables[iteratorNames.index] = index;
  if (iteratorNames.collection)
    scopeVariables[iteratorNames.collection] = items;
  return scopeVariables;
}
function isNumeric3(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function handler3() {
}
handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
  let root = closestRoot(el);
  if (!root._x_refs)
    root._x_refs = {};
  root._x_refs[expression] = el;
  cleanup2(() => delete root._x_refs[expression]);
};
directive("ref", handler3);
directive("if", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-if can only be used on a <template> tag", el);
  let evaluate2 = evaluateLater(el, expression);
  let show = () => {
    if (el._x_currentIfEl)
      return el._x_currentIfEl;
    let clone2 = el.content.cloneNode(true).firstElementChild;
    addScopeToNode(clone2, {}, el);
    mutateDom(() => {
      el.after(clone2);
      skipDuringClone(() => initTree(clone2))();
    });
    el._x_currentIfEl = clone2;
    el._x_undoIf = () => {
      mutateDom(() => {
        destroyTree(clone2);
        clone2.remove();
      });
      delete el._x_currentIfEl;
    };
    return clone2;
  };
  let hide = () => {
    if (!el._x_undoIf)
      return;
    el._x_undoIf();
    delete el._x_undoIf;
  };
  effect3(() => evaluate2((value) => {
    value ? show() : hide();
  }));
  cleanup2(() => el._x_undoIf && el._x_undoIf());
});
directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
  let names = evaluate2(expression);
  names.forEach((name) => setIdRoot(el, name));
});
interceptClone((from, to) => {
  if (from._x_ids) {
    to._x_ids = from._x_ids;
  }
});
mapAttributes(startingWith("@", into(prefix("on:"))));
directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
  let evaluate2 = expression ? evaluateLater(el, expression) : () => {
  };
  if (el.tagName.toLowerCase() === "template") {
    if (!el._x_forwardEvents)
      el._x_forwardEvents = [];
    if (!el._x_forwardEvents.includes(value))
      el._x_forwardEvents.push(value);
  }
  let removeListener = on(el, value, modifiers, (e) => {
    evaluate2(() => {
    }, { scope: { "$event": e }, params: [e] });
  });
  cleanup2(() => removeListener());
}));
warnMissingPluginDirective("Collapse", "collapse", "collapse");
warnMissingPluginDirective("Intersect", "intersect", "intersect");
warnMissingPluginDirective("Focus", "trap", "focus");
warnMissingPluginDirective("Mask", "mask", "mask");
function warnMissingPluginDirective(name, directiveName, slug) {
  directive(directiveName, (el) => warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
alpine_default.setEvaluator(normalEvaluator);
alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
var src_default$3 = alpine_default;
var module_default$3 = src_default$3;
function eager() {
  return true;
}
function event({ component, argument }) {
  return new Promise((resolve) => {
    if (argument) {
      window.addEventListener(
        argument,
        () => resolve(),
        { once: true }
      );
    } else {
      const cb = (e) => {
        if (e.detail.id !== component.id) return;
        window.removeEventListener("async-alpine:load", cb);
        resolve();
      };
      window.addEventListener("async-alpine:load", cb);
    }
  });
}
function idle() {
  return new Promise((resolve) => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(resolve);
    } else {
      setTimeout(resolve, 200);
    }
  });
}
function media({ argument }) {
  return new Promise((resolve) => {
    if (!argument) {
      console.log("Async Alpine: media strategy requires a media query. Treating as 'eager'");
      return resolve();
    }
    const mediaQuery = window.matchMedia(`(${argument})`);
    if (mediaQuery.matches) {
      resolve();
    } else {
      mediaQuery.addEventListener("change", resolve, { once: true });
    }
  });
}
function visible({ component, argument }) {
  return new Promise((resolve) => {
    const rootMargin = argument || "0px 0px 0px 0px";
    const observer2 = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        observer2.disconnect();
        resolve();
      }
    }, { rootMargin });
    observer2.observe(component.el);
  });
}
var strategies_default = {
  eager,
  event,
  idle,
  media,
  visible
};
async function awaitRequirements(component) {
  const requirements = parseRequirements(component.strategy);
  await generateRequirements(component, requirements);
}
async function generateRequirements(component, requirements) {
  if (requirements.type === "expression") {
    if (requirements.operator === "&&") {
      return Promise.all(
        requirements.parameters.map((param) => generateRequirements(component, param))
      );
    }
    if (requirements.operator === "||") {
      return Promise.any(
        requirements.parameters.map((param) => generateRequirements(component, param))
      );
    }
  }
  if (!strategies_default[requirements.method]) return false;
  return strategies_default[requirements.method]({
    component,
    argument: requirements.argument
  });
}
function parseRequirements(expression) {
  const tokens = tokenize(expression);
  let ast = parseExpression(tokens);
  if (ast.type === "method") {
    return {
      type: "expression",
      operator: "&&",
      parameters: [ast]
    };
  }
  return ast;
}
function tokenize(expression) {
  const regex = /\s*([()])\s*|\s*(\|\||&&|\|)\s*|\s*((?:[^()&|]+\([^()]+\))|[^()&|]+)\s*/g;
  const tokens = [];
  let match;
  while ((match = regex.exec(expression)) !== null) {
    const [_, parenthesis, operator, token] = match;
    if (parenthesis !== void 0) {
      tokens.push({ type: "parenthesis", value: parenthesis });
    } else if (operator !== void 0) {
      tokens.push({
        type: "operator",
        // we do the below to make operators backwards-compatible with previous
        // versions of Async Alpine, where '|' is equivalent to &&
        value: operator === "|" ? "&&" : operator
      });
    } else {
      const tokenObj = {
        type: "method",
        method: token.trim()
      };
      if (token.includes("(")) {
        tokenObj.method = token.substring(0, token.indexOf("(")).trim();
        tokenObj.argument = token.substring(
          token.indexOf("(") + 1,
          token.indexOf(")")
        );
      }
      if (token.method === "immediate") {
        token.method = "eager";
      }
      tokens.push(tokenObj);
    }
  }
  return tokens;
}
function parseExpression(tokens) {
  let ast = parseTerm(tokens);
  while (tokens.length > 0 && (tokens[0].value === "&&" || tokens[0].value === "|" || tokens[0].value === "||")) {
    const operator = tokens.shift().value;
    const right = parseTerm(tokens);
    if (ast.type === "expression" && ast.operator === operator) {
      ast.parameters.push(right);
    } else {
      ast = {
        type: "expression",
        operator,
        parameters: [ast, right]
      };
    }
  }
  return ast;
}
function parseTerm(tokens) {
  if (tokens[0].value === "(") {
    tokens.shift();
    const ast = parseExpression(tokens);
    if (tokens[0].value === ")") {
      tokens.shift();
    }
    return ast;
  } else {
    return tokens.shift();
  }
}
function async_alpine_default(Alpine2) {
  const directive2 = "load";
  const srcAttr = Alpine2.prefixed("load-src");
  const ignoreAttr = Alpine2.prefixed("ignore");
  let options = {
    defaultStrategy: "eager",
    keepRelativeURLs: false
  };
  let alias = false;
  let data2 = {};
  let realIndex = 0;
  function index() {
    return realIndex++;
  }
  Alpine2.asyncOptions = (opts) => {
    options = {
      ...options,
      ...opts
    };
  };
  Alpine2.asyncData = (name, download2 = false) => {
    data2[name] = {
      loaded: false,
      download: download2
    };
  };
  Alpine2.asyncUrl = (name, url) => {
    if (!name || !url || data2[name]) return;
    data2[name] = {
      loaded: false,
      download: () => import(
        /* @vite-ignore */
        /* webpackIgnore: true */
        parseUrl(url)
      )
    };
  };
  Alpine2.asyncAlias = (path) => {
    alias = path;
  };
  const syncHandler = (el) => {
    Alpine2.skipDuringClone(() => {
      if (el._x_async) return;
      el._x_async = "init";
      el._x_ignore = true;
      el.setAttribute(ignoreAttr, "");
    })();
  };
  const handler4 = async (el) => {
    Alpine2.skipDuringClone(async () => {
      if (el._x_async !== "init") return;
      el._x_async = "await";
      const { name, strategy } = elementPrep(el);
      await awaitRequirements({
        name,
        strategy,
        el,
        id: el.id || index()
      });
      if (!el.isConnected) return;
      await download(name);
      if (!el.isConnected) return;
      activate(el);
      el._x_async = "loaded";
    })();
  };
  handler4.inline = syncHandler;
  Alpine2.directive(directive2, handler4).before("ignore");
  function elementPrep(el) {
    const name = parseName(el.getAttribute(Alpine2.prefixed("data")));
    const strategy = el.getAttribute(Alpine2.prefixed(directive2)) || options.defaultStrategy;
    const urlAttributeValue = el.getAttribute(srcAttr);
    if (urlAttributeValue) {
      Alpine2.asyncUrl(name, urlAttributeValue);
    }
    return {
      name,
      strategy
    };
  }
  async function download(name) {
    if (name.startsWith("_x_async_")) return;
    handleAlias(name);
    if (!data2[name] || data2[name].loaded) return;
    const module = await getModule(name);
    Alpine2.data(name, module);
    data2[name].loaded = true;
  }
  async function getModule(name) {
    if (!data2[name]) return;
    const module = await data2[name].download(name);
    if (typeof module === "function") return module;
    let whichExport = module[name] || module.default || Object.values(module)[0] || false;
    return whichExport;
  }
  function activate(el) {
    Alpine2.destroyTree(el);
    el._x_ignore = false;
    el.removeAttribute(ignoreAttr);
    if (el.closest(`[${ignoreAttr}]`)) return;
    Alpine2.initTree(el);
  }
  function handleAlias(name) {
    if (!alias || data2[name]) return;
    if (typeof alias === "function") {
      Alpine2.asyncData(name, alias);
      return;
    }
    Alpine2.asyncUrl(name, alias.replaceAll("[name]", name));
  }
  function parseName(attribute) {
    const parsedName = (attribute || "").split(/[({]/g)[0];
    const ourName = parsedName || `_x_async_${index()}`;
    return ourName;
  }
  function parseUrl(url) {
    if (options.keepRelativeURLs) return url;
    const absoluteReg = new RegExp("^(?:[a-z+]+:)?//", "i");
    if (!absoluteReg.test(url)) {
      return new URL(url, document.baseURI).href;
    }
    return url;
  }
}
var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  return element.getRootNode();
} : function(element) {
  return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
  if (node.tabIndex < 0) {
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  var nodeRootHost = getRootNode(node).host;
  var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
  if (!displayCheck || displayCheck === "full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (nodeIsAttached) {
      return !node.getClientRects().length;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var activeFocusTraps = /* @__PURE__ */ function() {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }
      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
  return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event2) {
  return event2.target.shadowRoot && typeof event2.composedPath === "function" ? event2.composedPath()[0] : event2.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element) {
    return state.containerGroups.findIndex(function(_ref) {
      var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function(node) {
        return node === element;
      });
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = void 0;
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption("initialFocus");
    if (node === false) {
      return false;
    }
    if (node === void 0) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container,
        tabbableNodes,
        focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = focusableNodes.findIndex(function(n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return void 0;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function(n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function(group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus", previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkTab = function checkTab2(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (e.shiftKey) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, "onDeactivate");
      var onPostDeactivate = getOption(options, "onPostDeactivate");
      var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
      var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
      if (onDeactivate) {
        onDeactivate();
      }
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
function src_default$2(Alpine2) {
  let lastFocused;
  let currentFocused;
  window.addEventListener("focusin", () => {
    lastFocused = currentFocused;
    currentFocused = document.activeElement;
  });
  Alpine2.magic("focus", (el) => {
    let within = el;
    return {
      __noscroll: false,
      __wrapAround: false,
      within(el2) {
        within = el2;
        return this;
      },
      withoutScrolling() {
        this.__noscroll = true;
        return this;
      },
      noscroll() {
        this.__noscroll = true;
        return this;
      },
      withWrapAround() {
        this.__wrapAround = true;
        return this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(el2) {
        return isFocusable(el2);
      },
      previouslyFocused() {
        return lastFocused;
      },
      lastFocused() {
        return lastFocused;
      },
      focused() {
        return currentFocused;
      },
      focusables() {
        if (Array.isArray(within))
          return within;
        return focusable(within, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(el2) {
        let els = this.all();
        return els[0] && els[0].isSameNode(el2);
      },
      isLast(el2) {
        let els = this.all();
        return els.length && els.slice(-1)[0].isSameNode(el2);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1)
          return;
        if (this.__wrapAround && list.indexOf(current) === list.length - 1) {
          return list[0];
        }
        return list[list.indexOf(current) + 1];
      },
      getPrevious() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1)
          return;
        if (this.__wrapAround && list.indexOf(current) === 0) {
          return list.slice(-1)[0];
        }
        return list[list.indexOf(current) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(el2) {
        if (!el2)
          return;
        setTimeout(() => {
          if (!el2.hasAttribute("tabindex"))
            el2.setAttribute("tabindex", "0");
          el2.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  });
  Alpine2.directive("trap", Alpine2.skipDuringClone(
    (el, { expression, modifiers }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
      let evaluator = evaluateLater2(expression);
      let oldValue = false;
      let options = {
        escapeDeactivates: false,
        allowOutsideClick: true,
        fallbackFocus: () => el
      };
      if (modifiers.includes("noautofocus")) {
        options.initialFocus = false;
      } else {
        let autofocusEl = el.querySelector("[autofocus]");
        if (autofocusEl)
          options.initialFocus = autofocusEl;
      }
      let trap = createFocusTrap(el, options);
      let undoInert = () => {
      };
      let undoDisableScrolling = () => {
      };
      const releaseFocus = () => {
        undoInert();
        undoInert = () => {
        };
        undoDisableScrolling();
        undoDisableScrolling = () => {
        };
        trap.deactivate({
          returnFocus: !modifiers.includes("noreturn")
        });
      };
      effect3(() => evaluator((value) => {
        if (oldValue === value)
          return;
        if (value && !oldValue) {
          if (modifiers.includes("noscroll"))
            undoDisableScrolling = disableScrolling();
          if (modifiers.includes("inert"))
            undoInert = setInert(el);
          setTimeout(() => {
            trap.activate();
          }, 15);
        }
        if (!value && oldValue) {
          releaseFocus();
        }
        oldValue = !!value;
      }));
      cleanup2(releaseFocus);
    },
    // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate: evaluate2 }) => {
      if (modifiers.includes("inert") && evaluate2(expression))
        setInert(el);
    }
  ));
}
function setInert(el) {
  let undos = [];
  crawlSiblingsUp(el, (sibling) => {
    let cache = sibling.hasAttribute("aria-hidden");
    sibling.setAttribute("aria-hidden", "true");
    undos.push(() => cache || sibling.removeAttribute("aria-hidden"));
  });
  return () => {
    while (undos.length)
      undos.pop()();
  };
}
function crawlSiblingsUp(el, callback) {
  if (el.isSameNode(document.body) || !el.parentNode)
    return;
  Array.from(el.parentNode.children).forEach((sibling) => {
    if (sibling.isSameNode(el)) {
      crawlSiblingsUp(el.parentNode, callback);
    } else {
      callback(sibling);
    }
  });
}
function disableScrolling() {
  let overflow = document.documentElement.style.overflow;
  let paddingRight = document.documentElement.style.paddingRight;
  let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.overflow = "hidden";
  document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
  return () => {
    document.documentElement.style.overflow = overflow;
    document.documentElement.style.paddingRight = paddingRight;
  };
}
var module_default$2 = src_default$2;
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/
function src_default$1(Alpine2) {
  Alpine2.directive("intersect", Alpine2.skipDuringClone((el, { value, expression, modifiers }, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
    let evaluate2 = evaluateLater2(expression);
    let options = {
      rootMargin: getRootMargin(modifiers),
      threshold: getThreshold(modifiers)
    };
    let observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting === (value === "leave"))
          return;
        evaluate2();
        modifiers.includes("once") && observer2.disconnect();
      });
    }, options);
    observer2.observe(el);
    cleanup2(() => {
      observer2.disconnect();
    });
  }));
}
function getThreshold(modifiers) {
  if (modifiers.includes("full"))
    return 0.99;
  if (modifiers.includes("half"))
    return 0.5;
  if (!modifiers.includes("threshold"))
    return 0;
  let threshold = modifiers[modifiers.indexOf("threshold") + 1];
  if (threshold === "100")
    return 1;
  if (threshold === "0")
    return 0;
  return Number(`.${threshold}`);
}
function getLengthValue(rawValue) {
  let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
  return match ? match[1] + (match[2] || "px") : void 0;
}
function getRootMargin(modifiers) {
  const key = "margin";
  const fallback = "0px 0px 0px 0px";
  const index = modifiers.indexOf(key);
  if (index === -1)
    return fallback;
  let values = [];
  for (let i = 1; i < 5; i++) {
    values.push(getLengthValue(modifiers[index + i] || ""));
  }
  values = values.filter((v) => v !== void 0);
  return values.length ? values.join(" ").trim() : fallback;
}
var module_default$1 = src_default$1;
function src_default(Alpine2) {
  let persist = () => {
    let alias;
    let storage;
    try {
      storage = localStorage;
    } catch (e) {
      console.error(e);
      console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
      let dummy = /* @__PURE__ */ new Map();
      storage = {
        getItem: dummy.get.bind(dummy),
        setItem: dummy.set.bind(dummy)
      };
    }
    return Alpine2.interceptor((initialValue, getter, setter, path, key) => {
      let lookup = alias || `_x_${path}`;
      let initial = storageHas(lookup, storage) ? storageGet(lookup, storage) : initialValue;
      setter(initial);
      Alpine2.effect(() => {
        let value = getter();
        storageSet(lookup, value, storage);
        setter(value);
      });
      return initial;
    }, (func) => {
      func.as = (key) => {
        alias = key;
        return func;
      }, func.using = (target) => {
        storage = target;
        return func;
      };
    });
  };
  Object.defineProperty(Alpine2, "$persist", { get: () => persist() });
  Alpine2.magic("persist", persist);
  Alpine2.persist = (key, { get: get3, set: set3 }, storage = localStorage) => {
    let initial = storageHas(key, storage) ? storageGet(key, storage) : get3();
    set3(initial);
    Alpine2.effect(() => {
      let value = get3();
      storageSet(key, value, storage);
      set3(value);
    });
  };
}
function storageHas(key, storage) {
  return storage.getItem(key) !== null;
}
function storageGet(key, storage) {
  let value = storage.getItem(key, storage);
  if (value === void 0)
    return;
  return JSON.parse(value);
}
function storageSet(key, value, storage) {
  storage.setItem(key, JSON.stringify(value));
}
var module_default = src_default;
console.log(
  `%c

 (   (
 )\\ ))\\ )   (      (
(()/(()/(   )\\   ( )\\
 /(_))(_)|(((_)( )((_)
(_))(_))  )\\ _ )((_)_
/ __| |   (_)_\\(_) _ )
\\__ \\ |__  / _ \\ | _ \\
|___/____|/_/ \\_\\|___/

Site built with the Slab theme
By https://brickspacelab.com

`,
  "color: black; font-weight: bold;"
);
module_default$3.plugin(async_alpine_default);
module_default$3.plugin(module_default);
module_default$3.plugin(module_default$2);
module_default$3.plugin(module_default$1);
module_default$3.asyncAlias((name) => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "../javascript/components/ageVerification.ts": () => __vitePreload(() => import("./ageVerification-BV0m4CJV.js"), true ? [] : void 0, import.meta.url), "../javascript/components/alert.ts": () => __vitePreload(() => import("./alert-CZOyxuQk.js"), true ? [] : void 0, import.meta.url), "../javascript/components/blockVisibility.ts": () => __vitePreload(() => import("./blockVisibility-C0wW_MgS.js"), true ? [] : void 0, import.meta.url), "../javascript/components/bundles.ts": () => __vitePreload(() => import("./bundles-BpUVcv_m.js"), true ? [] : void 0, import.meta.url), "../javascript/components/cartGifts.ts": () => __vitePreload(() => Promise.resolve().then(() => cartGifts$1), true ? void 0 : void 0, import.meta.url), "../javascript/components/cartProgress.ts": () => __vitePreload(() => import("./cartProgress-C9Ox6u9S.js"), true ? [] : void 0, import.meta.url), "../javascript/components/cartShare.ts": () => __vitePreload(() => import("./cartShare-BJiP6Wd-.js"), true ? [] : void 0, import.meta.url), "../javascript/components/countdown.ts": () => __vitePreload(() => import("./countdown-Crmt3y2q.js"), true ? [] : void 0, import.meta.url), "../javascript/components/filter.ts": () => __vitePreload(() => import("./filter-BvJK5fpo.js"), true ? [] : void 0, import.meta.url), "../javascript/components/filterPriceRange.ts": () => __vitePreload(() => import("./filterPriceRange-CaWtTYSA.js"), true ? [] : void 0, import.meta.url), "../javascript/components/gridPaginateItem.ts": () => __vitePreload(() => import("./gridPaginateItem-Cdd7de83.js"), true ? [] : void 0, import.meta.url), "../javascript/components/imageComparison.ts": () => __vitePreload(() => import("./imageComparison-C4M-pU_Z.js"), true ? [] : void 0, import.meta.url), "../javascript/components/map.ts": () => __vitePreload(() => import("./map-DfOiEbK8.js"), true ? [] : void 0, import.meta.url), "../javascript/components/menuDropdown.ts": () => __vitePreload(() => import("./menuDropdown-Bjlmqkhd.js"), true ? [] : void 0, import.meta.url), "../javascript/components/menuPage.ts": () => __vitePreload(() => import("./menuPage-Cu9tJz2H.js"), true ? [] : void 0, import.meta.url), "../javascript/components/model.ts": () => __vitePreload(() => import("./model-Ba7I7zJl.js"), true ? [] : void 0, import.meta.url), "../javascript/components/pagination.ts": () => __vitePreload(() => import("./pagination-P9SCtGmM.js"), true ? [] : void 0, import.meta.url), "../javascript/components/purchaseOfferGallery.ts": () => __vitePreload(() => import("./purchaseOfferGallery-JFVQE0kW.js"), true ? [] : void 0, import.meta.url), "../javascript/components/purchaseOffers.ts": () => __vitePreload(() => import("./purchaseOffers-Bi4yPvZw.js"), true ? [] : void 0, import.meta.url), "../javascript/components/recommendations.ts": () => __vitePreload(() => import("./recommendations-DkOEoae4.js"), true ? [] : void 0, import.meta.url), "../javascript/components/renderSection.ts": () => __vitePreload(() => import("./renderSection-N-IFeKdw.js"), true ? [] : void 0, import.meta.url), "../javascript/components/searchResults.ts": () => __vitePreload(() => import("./searchResults-DBMsfjDF.js"), true ? [] : void 0, import.meta.url), "../javascript/components/slider.ts": () => __vitePreload(() => import("./slider-BTm6TBdJ.js"), true ? [] : void 0, import.meta.url), "../javascript/components/tabs.ts": () => __vitePreload(() => import("./tabs-BLl1S6mt.js"), true ? [] : void 0, import.meta.url), "../javascript/components/textarea.ts": () => __vitePreload(() => import("./textarea-CcGd5Tit.js"), true ? [] : void 0, import.meta.url) }), `../javascript/components/${name}.ts`, 4));
window.Alpine = module_default$3;
module_default$3.data("cartGifts", cartGifts);
module_default$3.start();
